import React, { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchEmployees } from "../../../../../store/slices/employeeSlice";
import { fetchAllProjects } from "../../../../../store/slices/projectsSlice";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FileUploadSales from "./FileUploadSales";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSnackbar } from "notistack";
import AdminLoader from "../../../../../components/common/loader/AdminLoader";
import { fetchWorkEntries } from "../../../../../store/slices/workentriesSlice";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { fetchHardwareDescriptions } from "./../../../../../store/slices/hardwareDescriptionSlice";
import { fetchDescriptionTasks } from "../../../../../store/slices/DescriptionTask";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import {
  salespersonRejectProject,
} from "../../../../../store/slices/SalesPersonProjectRejectSlice";
import { cancelManagerFromProjects } from "../../../../../store/slices/cancelManagerSlice";
import QuotedExpenseTable from "./QuotedExpenseTable";
import { fetchQuotations } from "../../../../../store/slices/hourlyRates";
import { fetchSalesTaxes } from "../../../../../store/slices/salesTaxesSlice";
import { useCurrencySymbol } from "../../../../../utils/currencyUtils";
import DateConversion from "../../../../../utils/DateConversion";
import CommaConvert from "../../../../../utils/CommaConvert";
import {
  formatAmountComma,
  parseAmountNumber,
} from "../../../../../utils/decimalAmountUtils";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import { fetchSalesHourlyRates } from "../../../../../store/slices/salesHourlyRateSlice";
import { salespersonAcceptAction } from "../../../../../store/slices/salespersonAcceptAction";
import ConsolidatedHardware from "./ConsolidatedHardware";
import { fetchGroups } from "../../../../../store/slices/groupSlice";
import { getMyTrainings } from "../../../../../store/slices/MyTraining/myTrainings";
import {
  consolidateTrainingExpenseRowsForDisplay,
  filterInstallationOngoingOtherExpenseDisplayRows,
  isTrainingExpenseDisplayRow,
} from "../../../../../utils/trainingOtherExpenseSync";
import {
  getLoggedSalesUserId,
  getPerdiemAndAverageCostFromExpenses,
  scopeOtherExpensesForUser,
} from "../../../../../utils/salespersonRatesScope";
import { fetchOtherExpenses } from "../../../../../store/slices/otherexpenses";
// import UseExpensesData from "./useExpensesData";

const ResponseReceived = ({ handlerefresh, projectsReceived, isViewOnly = false }) => {
  const dispatch = useDispatch();
  const USAComma = CommaConvert();
  const currency = useCurrencySymbol();
  const { formatDateByCountry } = DateConversion();

  const { enqueueSnackbar } = useSnackbar();
  const { employees } = useSelector((state) => state.employees);
  const { tasks } = useSelector((state) => state.descriptionTasks);
  const { entries } = useSelector((state) => state.workentries);
  const { items } = useSelector((state) => state.hardwareDescription);
  const { group: masterGroups } = useSelector((state) => state.group);
  const { data } = useSelector((state) => state.salesHourlyRate);
  const { mytrainings } = useSelector((state) => state.myTrainings);
  useEffect(() => {
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchWorkEntries());
    dispatch(fetchEmployees());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchAllProjects());
    dispatch(getMyTrainings());
    dispatch(fetchQuotations());
    dispatch(fetchSalesTaxes());
    dispatch(fetchSalesHourlyRates());
    dispatch(fetchOtherExpenses());
    dispatch(fetchGroups());
  }, [dispatch]);

  useEffect(() => {
    const refreshHourlyRates = () => {
      dispatch(fetchSalesHourlyRates());
    };

    window.addEventListener("focus", refreshHourlyRates);
    window.addEventListener("pageshow", refreshHourlyRates);
    window.addEventListener("sales-hourly-rates-updated", refreshHourlyRates);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshHourlyRates();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("focus", refreshHourlyRates);
      window.removeEventListener("pageshow", refreshHourlyRates);
      window.removeEventListener(
        "sales-hourly-rates-updated",
        refreshHourlyRates
      );
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [dispatch]);
  const [activeTaskKey, setActiveTaskKey] = useState(null);
  const [currentProject, setCurrentProject] = useState(null);
  const [showAttach, setShowAttach] = useState(false);
  const [probabilityList] = useState([]);
  const [isLoading, SetisLoading] = useState(false);
  const [rowid, setrowid] = useState(null);
  const [openInputReceived, setOpenInputReceived] = useState(null);
  // const [
  //   openProjectDropdown, setOpenProjectDropdown] = useState({
  //   rowIndex: null,
  //   projectIndex: null,
  // });
  const [selected, setSelected] = useState(false);
  const [showExpensesForProject, setShowExpensesForProject] = useState(null); // Track project index that should show expenses
  const [showConsolidatedPartsProject, setShowConsolidatedPartsProject] = useState(null); // Track project index that should show expenses
  const { projects } = useSelector((state) => state.projects);
  const [perdiem, setperdiem] = useState(0);
  const [averagecost, setaveragecost] = useState(0);
  const [searchedLeadReports, setsearchedLeadReports] = useState([]);
  const { items: otherExpenses } = useSelector((state) => state.otherExpenses);
  const loggedInUserId = useSelector((state) => state.leads.loggedInUserId);
  const plEmail =
    typeof localStorage !== "undefined" ? localStorage.getItem("email") : "";
  const loggedUserIdForExpenses = React.useMemo(
    () => getLoggedSalesUserId(loggedInUserId, employees, plEmail),
    [loggedInUserId, employees, plEmail]
  );
  const [expenseTableData, setexpenseTableData] = useState("");
  const [, setHighlightedExpenses] = useState(null);
  const [, setHighlightedConsolidatedParts] = useState(null);
  const [hourlyRateData, setHourlyRateData] = useState([]);
  const resolveId = (value) => {
    if (!value) return "";
    if (typeof value === "string" || typeof value === "number") {
      return String(value).trim();
    }
    return String(value?._id || value?.id || "").trim();
  };

  const getGroupDisplayName = (row) => {
    const groupId =
      resolveId(row?.projectdata?.groupid) ||
      resolveId(row?.groupid) ||
      resolveId(row?.lead?.groupid);

    if (!groupId) return "";

    const matchedGroup = (masterGroups || []).find(
      (group) => resolveId(group?._id) === groupId
    );

    return (
      matchedGroup?.newGroupName ||
      matchedGroup?.GroupName ||
      matchedGroup?.groupName ||
      matchedGroup?.name ||
      ""
    );
  };

  console.log("showConsolidatedPartsProject", showConsolidatedPartsProject);

  useEffect(() => {
    const email = localStorage.getItem("email")
    const employee = employees.find((emp) => emp.EmpEmail === email);

    const filtereddatat = data.filter(
      (proj) => proj.createdBy === employee?._id
    );

    setHourlyRateData(filtereddatat)
  }, [data, employees]);
  useEffect(() => {
    setsearchedLeadReports(projectsReceived);
  }, [projectsReceived]);
  // Reset highlight when no expenses are shown
  useEffect(() => {
    if (!showExpensesForProject) {
      setHighlightedExpenses(null);
    }
  }, [showExpensesForProject]);
  useEffect(() => {
    const expensesForUser = scopeOtherExpensesForUser(otherExpenses, {
      loggedUserId: loggedUserIdForExpenses,
    });
    const { perdiem: p, averagecost: a } =
      getPerdiemAndAverageCostFromExpenses(expensesForUser);
    setperdiem(p);
    setaveragecost(a);
  }, [otherExpenses, loggedUserIdForExpenses]);
  const responsereceiveddref = useRef(null);
  useEffect(() => {
    if (rowid) {
      // Scroll to the right end of the container
      const scrollToPosition = responsereceiveddref.current.scrollWidth;
      responsereceiveddref.current.scrollTo({
        left: scrollToPosition,
        behavior: "smooth",
      });
    }
  }, [rowid]);
  const dropdownRefOpenInput = useRef([]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        openInputReceived !== null &&
        dropdownRefOpenInput.current[openInputReceived] &&
        !dropdownRefOpenInput.current[openInputReceived].contains(event.target)
      ) {
        setOpenInputReceived(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openInputReceived]);

  const handleCancel = async (project) => {
    if (isViewOnly) return;
    const projectId = project._id;
    SetisLoading(true);
    try {
      await dispatch(cancelManagerFromProjects(projectId)).unwrap();
      enqueueSnackbar("Manager Removed Successfully", {
        variant: "success",
      });
      SetisLoading(false);
    } catch (error) {
      console.error("Failed to create task:", error);
      SetisLoading(false);
    } finally {
      handlerefresh();
      SetisLoading(false);
    }
    dispatch(fetchAllProjects());
  };

  const handleReject = async (row, project, index, Status) => {
    if (isViewOnly) return;
    const projectId = project._id;
    SetisLoading(true);
    try {
      await dispatch(salespersonRejectProject({ projectId }));
      enqueueSnackbar("Project Rejected Successfully", { variant: "success" });
      dispatch(fetchAllProjects());
    } catch (error) {
      console.error("Update error:", error);
      enqueueSnackbar("Update failed. See console for details.", {
        variant: "error",
      });
    } finally {
      handlerefresh();
      SetisLoading(false);
      // SetShowproject(false);
      setOpenInputReceived(openInputReceived === index ? null : index);
    }
    // setOpenProjectDropdown({ rowIndex: null, projectIndex: null });
  };

  // Helper function to build finalMappedEntries (simplified version)
  const buildFinalMappedEntries = (matchedEntries, employees) => {
    if (!matchedEntries.length || !employees.length) return [];

    const mapped = matchedEntries.map((entry) => {
      const matchedEmp = employees.find((emp) => emp._id === entry.taskownerid);

      // Check if this is a hardware entry
      const isHardwareEntry =
        entry.hasOwnProperty("assemblepartdescription") ||
        entry.hasOwnProperty("partno") ||
        entry.hasOwnProperty("quantity");

      if (isHardwareEntry) {
        return {
          createdBy: {
            email: matchedEmp?.EmpEmail || "",
            name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""
              }`,
            role: matchedEmp?.customRoles || [],
          },
          assemblepartdescription: entry.assemblepartdescription,
          partno: entry.partno,
          quantity: entry.quantity,
          unitprice: entry.unitprice,
          totalprice: entry.totalprice,
          permonth: entry.permonth,
          taskstatus: entry.taskstatus,
          _id: entry._id,
          taskownerid: entry.taskownerid,
          TypeService: entry.typeservice || "Hardware",
          projectid: entry.projectid,
        };
      } else {
        return {
          createdBy: {
            email: matchedEmp?.EmpEmail || "",
            name: `${matchedEmp?.EmpFirstName || ""} ${matchedEmp?.EmpLastName || ""
              }`,
            role: matchedEmp?.customRoles || [],
          },
          task: entry.task,
          hoursassigned: entry.hoursassigned,
          taskStatus: entry.taskStatus,
          notes: entry.notes,
          _id: entry._id,
          taskownerid: entry.taskownerid,
          TypeService: entry.typeservice || matchedEmp?.servicetype,
          projectid: entry.projectid,
        };
      }
    });

    return mapped;
  };

  // Helper function to calculate description total value
  const calculateDescriptionTotal = (
    projectID,
    personID,
    typeService,
    tasks,
    perdiem,
    averagecost
  ) => {
    if (!tasks) return 0;

    const descriptions = tasks.filter(
      (desc) => desc.projectid === projectID && desc.taskownerid === personID
    );

    let totalValue = descriptions.reduce(
      (sum, desc) => sum + (desc.value || 0),
      0
    );

    // Check if this is an Installation service
    if (typeService && typeService.toLowerCase().includes("installation")) {
      let maxTripDuration = 0;
      const uniqueTripDurations = new Set();

      descriptions.forEach((desc) => {
        if (desc.tripduration) {
          uniqueTripDurations.add(desc.tripduration);
          maxTripDuration = Math.max(maxTripDuration, desc.tripduration);
        }
      });

      if (maxTripDuration > 0) {
        totalValue += maxTripDuration * perdiem + maxTripDuration * averagecost;
      }
    }

    return totalValue;
  };

  // Helper function to calculate hardware total value
  const calculateHardwareTotal = (projectID, typeService, items) => {
    if (!items) return 0;

    const hardwareCost = items.filter(
      (desc) => desc.projectid === projectID && desc.typeservice === typeService
    );

    let hardwareValue = 0;
    const hardwareByDescription = {};

    // Group hardware by assemblepartdescription and keep only the one with highest totalprice
    hardwareCost.forEach((hw) => {
      const description = hw.assemblepartdescription;

      if (!hardwareByDescription[description]) {
        hardwareByDescription[description] = hw;
      } else {
        if (hw.totalprice > hardwareByDescription[description].totalprice) {
          hardwareByDescription[description] = hw;
        }
      }
    });

    // Calculate total hardware value
    Object.values(hardwareByDescription).forEach((hw) => {
      if (hw.totalprice) {
        hardwareValue += hw.totalprice;
      }
    });

    return hardwareValue;
  };

  // Updated getFilteredQuotationForProject function with everything built inside
  const getFilteredQuotationForProject = (
    row,
    projects,
    employees,
    entries,
    items,
    tasks,
    data,
    perdiem,
    averagecost
  ) => {
    if (
      !row ||
      !projects ||
      !employees ||
      !entries ||
      !items ||
      !tasks ||
      !data
    ) {
      return null;
    }

    const projectName = row.ProjectName || row.projectName;
    const typeService = row.TypeService; // ADD THIS LINE - get the specific service type
    if (!projectName || !typeService) return null; // ADD typeService check

    // Step 1: Find the specific project with BOTH name and service type
    const specificProject = projects.find(
      (proj) =>
        proj.ProjectName === projectName &&
        proj.TypeService === typeService // ADD this filter
    );

    if (!specificProject) {
      console.log(`Project not found: ${projectName} - ${typeService}`);
      return null;
    }

    // Step 2: Get matched entries for this specific project (same as before)
    const projectEntries = entries.filter(
      (entry) => entry.projectid === specificProject._id
    );
    const projectItems = items.filter(
      (item) => item.projectid === specificProject._id
    );

    // Combine entries and items for matchedEntries
    const matchedEntries = [...projectEntries, ...projectItems];

    // Step 3: Build finalMappedEntries
    const finalMappedEntries = buildFinalMappedEntries(
      matchedEntries,
      employees
    );

    // Step 4: Build groupedProj for this specific project
    const groupedProj = {};
    groupedProj[projectName] = {};

    const projectId = specificProject._id;

    // Filter entries by the specific service type
    const matchedEntriesForProject = finalMappedEntries.filter(
      (entry) =>
        entry.TypeService === typeService && entry.projectid === projectId
    );

    if (matchedEntriesForProject.length > 0) {
      const salesperson = employees.find(
        (emp) => emp.EmpEmail === specificProject.SalesPersonEmail
      );

      const filteredProject = {
        TypeService: specificProject.TypeService,
        ResourceType: specificProject.ResourceType,
        ProjectName: specificProject.ProjectName,
        QuotedValue: specificProject.ServiceValue,
        ProjectMargin: specificProject.Salesmargin,
        WorkEntries: matchedEntriesForProject,
        AssignedGroup: getGroupDisplayName(specificProject),
        groupid: specificProject.groupid,
        AssignedManagerEmail: specificProject.AssignedManagerEmail,
        Assignedperson: specificProject.Assignedperson,
        ProjectID: specificProject._id,
        ProjectNotes: specificProject?.ProjectFinanceNotes,
        SalesPersonId: salesperson ? salesperson._id : null,
      };

      if (!groupedProj[projectName][typeService]) {
        groupedProj[projectName][typeService] = [];
      }

      groupedProj[projectName][typeService].push(filteredProject);
    }

    // Step 5: Match quotations
    const result = {};
    result[projectName] = {};

    Object.entries(groupedProj[projectName]).forEach(
      ([serviceType, serviceArray]) => {
        const updatedServiceArray = serviceArray.map((entry) => {
          const matchedQuotations = data.filter(
            (q) =>
              q.designation
                ?.toLowerCase()
                .includes(serviceType.toLowerCase()) &&
              q.createdBy === entry.SalesPersonId
          );

          return {
            ...entry,
            quotationDetails: matchedQuotations,
          };
        });

        result[projectName][serviceType] = updatedServiceArray;
      }
    );

    return result;
  };
  // Updated getTransformedQuotationData function
  const getTransformedQuotationData = (
    filteredQuotation,
    employees,
    tasks,
    items,
    perdiem,
    averagecost
  ) => {
    if (!filteredQuotation || !employees) return [];

    const result = [];

    Object.entries(filteredQuotation).forEach(([projectName, typeServices]) => {
      Object.entries(typeServices).forEach(([typeService, itemsArray]) => {
        itemsArray.forEach((item) => {
          if (!item?.WorkEntries?.length) return;

          // Group work entries by person
          const groupedByPerson = {};
          const personRoleMap = {};

          item.WorkEntries.forEach((entry) => {
            const personName = entry?.createdBy?.name;
            const personRoles = entry?.createdBy?.role || [];
            const personId = entry?.taskownerid;

            if (!groupedByPerson[personName]) {
              groupedByPerson[personName] = { totalHours: 0, personId };
            }
            groupedByPerson[personName].totalHours += entry.hoursassigned || 0;

            if (!personRoleMap[personName]) {
              personRoleMap[personName] = { roles: personRoles, personId };
            }
          });

          // Convert grouped persons into array with costs
          Object.entries(groupedByPerson).forEach(([name, personData]) => {
            const totalHours = personData.totalHours;
            const personId = personData.personId;
            const ProjectID = item?.ProjectID;
            const ProjectNotes = item?.ProjectNotes;
            const ServiceQuotedValue = item?.QuotedValue;
            const servicewiseMargin = item?.ProjectMargin;

            // Match quotation by personid
            const matchedQuotation = item?.quotationDetails?.find(
              (q) => q.personid === personId
            );

            const currentEmployee = employees.find((emp) => {
              const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`
                .trim()
                .toLowerCase();
              return fullName === name.trim().toLowerCase();
            });

            const capitalizedRoles =
              currentEmployee?.customRoles?.map(
                (role) =>
                  role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
              ) || [];

            const hourlyRate =
              (matchedQuotation?.hourlysalaray || 0) +
              (matchedQuotation?.overheadpercentage || 0);

            const totalCost = totalHours * hourlyRate;

            // Calculate description total
            const descriptionTotal = calculateDescriptionTotal(
              item.ProjectID,
              personId,
              item.TypeService,
              tasks,
              perdiem,
              averagecost
            );

            // Calculate hardware total
            const hardwareTotal = calculateHardwareTotal(
              item.ProjectID,
              item.TypeService,
              items
            );

            const hasProjectManagerRole =
              capitalizedRoles.includes("Project manager");

            result.push({
              servicewiseMargin,
              ServiceQuotedValue,
              projectName,
              typeService: item.TypeService,
              resourceType: item.ResourceType,
              personId,
              ProjectID,
              ProjectNotes,
              personName: name,
              roles: capitalizedRoles,
              totalHours,
              hourlyRate,
              totalCost,
              descriptionTotal,
              hardwareTotal,
              grandTotal: item?.TypeService?.toLowerCase().includes("hardware")
                ? (hasProjectManagerRole ? hardwareTotal : 0) + descriptionTotal
                : descriptionTotal + totalCost,
            });
          });
        });
      });
    });

    return result;
  };

  const getDescriptionValues = useCallback(
    (projectID, personID, typeService) => {
      if (!tasks) return [];
      return tasks.filter(
        (desc) => desc.projectid === projectID && desc.taskownerid === personID
      );
    },
    [tasks]
  );


  const getTotalDescriptionValue = useCallback(
    (projectID, personID, typeService) => {
      const descriptions = getDescriptionValues(projectID, personID, typeService);

      let totalValue = descriptions.reduce((sum, desc) => sum + (desc.value || 0), 0);

      // Check if this is an Installation service
      if (typeService && typeService.toLowerCase().includes('installation')) {
        // Find the maximum trip duration for this person (to avoid duplicate counting)
        let maxTripDuration = 0;
        const uniqueTripDurations = new Set();

        descriptions.forEach(desc => {
          if (desc.tripduration) {
            uniqueTripDurations.add(desc.tripduration);
            maxTripDuration = Math.max(maxTripDuration, desc.tripduration);
          }
        });

        // Use the maximum trip duration for calculation
        // If you want to use average trip duration instead, you can calculate:
        // const avgTripDuration = Array.from(uniqueTripDurations).reduce((sum, duration) => sum + duration, 0) / uniqueTripDurations.size;

        if (maxTripDuration > 0) {
          // Add: (tripduration * perdiem) + (tripduration * averageCost)
          totalValue += (maxTripDuration * perdiem) + (maxTripDuration * averagecost);
        }
      }

      return totalValue;
    },
    [getDescriptionValues, perdiem, averagecost] // Add perdiem and averageCost to dependencies
  );

  const getHardwareValues = useCallback(
    (projectID, typeService) => {
      if (!items) return [];
      return items.filter(
        (desc) =>
          desc.projectid === projectID &&
          // desc.taskownerid === personID &&
          desc.typeservice === typeService
      );
    },
    [items]
  );

  const getTotalHardwareCostValue = useCallback(
    (projectID, personID, typeService) => {
      let hardwareValue = 0;
      const hardwareCost = getHardwareValues(projectID, typeService);
      const hardwareByDescription = {};

      // Group hardware by assemblepartdescription and keep only the one with highest totalprice
      hardwareCost.forEach((hw) => {
        const description = hw.assemblepartdescription;

        if (!hardwareByDescription[description]) {
          hardwareByDescription[description] = hw;
        } else {
          // If we already have this description, keep the one with higher totalprice
          if (hw.totalprice > hardwareByDescription[description].totalprice) {
            hardwareByDescription[description] = hw;
          }
        }
      });

      // Calculate total hardware value using only the highest totalprice items
      Object.values(hardwareByDescription).forEach((hw) => {
        if (hw.totalprice) {
          hardwareValue += hw.totalprice;
        }
      });
      return hardwareValue
      // return hardwareCost.reduce((sum, desc) => sum + (desc.totalprice || 0), 0);
    },
    [getHardwareValues]
  );

  const transformFilteredQuotation = useCallback((filteredQuotation, employees) => {
    const result = [];

    Object.entries(filteredQuotation || {}).forEach(([projectName, typeServices]) => {
      Object.entries(typeServices).forEach(([typeService, items]) => {
        items.forEach((item) => {
          if (!item?.WorkEntries?.length) return;

          // Group work entries by person
          const groupedByPerson = {};
          const personRoleMap = {};

          item.WorkEntries.forEach((entry) => {
            const personName = entry?.createdBy?.name;
            const personRoles = entry?.createdBy?.role || [];
            const personId = entry?.taskownerid;

            if (!groupedByPerson[personName]) {
              groupedByPerson[personName] = { totalHours: 0, personId };
            }
            groupedByPerson[personName].totalHours += entry.hoursassigned || 0;

            if (!personRoleMap[personName]) {
              personRoleMap[personName] = { roles: personRoles, personId };
            }
          });

          console.log("personRoleMap", personRoleMap);
          console.log("item quotationDetails", item.quotationDetails);

          // Convert grouped persons into array with costs
          Object.entries(groupedByPerson).forEach(([name, personData]) => {
            const totalHours = personData.totalHours;
            const personId = personData.personId;
            const ProjectID = item?.ProjectID;
            const ProjectNotes = item?.ProjectNotes;
            const ServiceQuotedValue = item?.QuotedValue;
            const servicewiseMargin = item?.ProjectMargin;

            // Get roles for this person
            const personRoleInfo = personRoleMap[name];
            const personRoles = personRoleInfo?.roles || [];

            console.log("Person Name:", name);
            console.log("Person Roles:", personRoles);

            // Find matching quotation based on roles
            let matchedQuotation = null;

            if (item.quotationDetails) {
              // Try to match by checking if any role matches the designation
              // Since personRoles is an array and designation is a string, we need to check each role
              for (const role of personRoles) {
                matchedQuotation = item.quotationDetails.find(q =>
                  q.designation.toLowerCase() === role.toLowerCase()
                );

                if (matchedQuotation) {
                  console.log(`Matched role "${role}" with designation "${matchedQuotation.designation}"`);
                  break;
                }
              }

              // If no match found with exact role, try partial matching
              if (!matchedQuotation) {
                for (const role of personRoles) {
                  matchedQuotation = item.quotationDetails.find(q =>
                    q.designation.toLowerCase().includes(role.toLowerCase()) ||
                    role.toLowerCase().includes(q.designation.toLowerCase())
                  );

                  if (matchedQuotation) {
                    console.log(`Partially matched role "${role}" with designation "${matchedQuotation.designation}"`);
                    break;
                  }
                }
              }
            }

            console.log("Matched Quotation:", matchedQuotation);

            const currentEmployee = employees.find((emp) => {
              const fullName = `${emp.EmpFirstName} ${emp.EmpLastName}`.trim().toLowerCase();
              return fullName === name.trim().toLowerCase();
            });

            const capitalizedRoles =
              currentEmployee?.customRoles?.map(
                (role) =>
                  role.charAt(0).toUpperCase() + role.slice(1).toLowerCase()
              ) || [];

            // Use matched quotation hourly rate, fallback to 0 if not found
            const hourlyRate = matchedQuotation ?
              (matchedQuotation?.hourlysalaray || 0) + (matchedQuotation?.overheadpercentage || 0) : 0;

            const totalCost = totalHours * hourlyRate;

            // External helpers
            const descriptionTotal = getTotalDescriptionValue(
              item.ProjectID,
              personId,
              item.TypeService
            );

            const hardwareTotal = getTotalHardwareCostValue(
              item.ProjectID,
              personId,
              item.TypeService
            );

            const hasProjectManagerRole = capitalizedRoles.includes("Project manager");
            result.push({
              servicewiseMargin,
              ServiceQuotedValue,
              projectName,
              typeService: item.TypeService,
              resourceType: item.ResourceType,
              personId,
              ProjectID,
              ProjectNotes,
              personName: name,
              roles: capitalizedRoles,
              totalHours,
              hourlyRate,
              totalCost,
              descriptionTotal,
              hardwareTotal,
              grandTotal:
                item?.TypeService?.toLowerCase().includes("hardware")
                  ? (hasProjectManagerRole ? hardwareTotal : 0) + descriptionTotal
                  : descriptionTotal + totalCost,
              matchedDesignation: matchedQuotation?.designation || 'Not matched'
            });
          });
        });
      });
    });

    return result;
  }, [getTotalDescriptionValue, getTotalHardwareCostValue]);

  const groupByTypeService = (processedData) => {
    return processedData.reduce((acc, curr) => {
      if (!acc[curr.typeService]) {
        acc[curr.typeService] = [];
      }
      acc[curr.typeService].push(curr);
      return acc;
    }, {});
  };


  const handleAccept = async (row, project, index, Status) => {
    if (isViewOnly) return;
    console.log("acacasafasfs project", project);

    // First, find ALL projects with the same ProjectName
    const allRelatedProjects = projects.filter(
      (proj) => proj.ProjectName === project.ProjectName
    );

    console.log("All related projects for", project.ProjectName, ":", allRelatedProjects);

    // Process each related project to get aggregated data
    const allGroupedData = {};

    allRelatedProjects.forEach((relatedProject) => {
      const filteredQuotationData = getFilteredQuotationForProject(
        relatedProject,
        projects,
        employees,
        entries,
        items,
        tasks,
        hourlyRateData,
        perdiem,
        averagecost
      );

      if (filteredQuotationData) {
        // Get transformed data for this specific project
        let transformedData = [];
        try {
          transformedData = getTransformedQuotationData(
            filteredQuotationData,
            employees,
            tasks,
            items,
            perdiem,
            averagecost
          );
        } catch (error) {
          console.error("Error transforming data for", relatedProject.TypeService, ":", error);
        }

        console.log(`Transformed data for ${relatedProject.TypeService}:`, transformedData);

        // Process and merge the data
        const processedData = transformFilteredQuotation(filteredQuotationData, employees);
        const groupedData = groupByTypeService(processedData);

        // Merge this groupedData into the main allGroupedData object
        Object.entries(groupedData).forEach(([typeService, dataArray]) => {
          if (!allGroupedData[typeService]) {
            allGroupedData[typeService] = [];
          }
          allGroupedData[typeService].push(...dataArray);
        });

        console.log(`Grouped data for ${relatedProject.TypeService}:`, groupedData);
      }
    });

    console.log("Combined groupedData for all services:", allGroupedData);

    // Now you have allGroupedData containing data for ALL service types
    // Example structure:
    // {
    //   "Software": [{...}, {...}],
    //   "Cloud": [{...}, {...}],
    //   "Hardware": [{...}]
    // }

    // You can calculate totals across all services
    let totalCostAllServices = 0;
    let serviceBreakdown = {};

    Object.entries(allGroupedData).forEach(([typeService, dataArray]) => {
      const serviceTotal = dataArray.reduce((sum, item) => sum + (item.grandTotal || 0), 0);
      serviceBreakdown[typeService] = {
        total: serviceTotal,
        items: dataArray.length,
        people: dataArray.map(item => item.personName)
      };
      totalCostAllServices += serviceTotal;
    });

    console.log("Service Breakdown:", serviceBreakdown);
    console.log("Total Cost for all services:", totalCostAllServices);


    const clickedServiceType = project.TypeService;
    const clickedServiceBreakdown = {};

    if (serviceBreakdown[clickedServiceType]) {
      clickedServiceBreakdown[clickedServiceType] = serviceBreakdown[clickedServiceType];
    }

    console.log("Filtered service breakdown (only clicked service):", clickedServiceBreakdown);

    const updatedAssignedPerson = (project.Assignedperson || []).map(
      (person) => ({
        ...person,
        salespersonaction: "accept",
      })
    );

    const updatedRow = {
      ProjectName: project.ProjectName,
      ProjectDueDate: project.ProjectDueDate || "",
      updateData: {
        AssignedManagerEmail: project.AssignedManagerEmail,
        Assignedperson: updatedAssignedPerson,
        WorkEntries: project.WorkEntries,
        // SalesPersonAction: "accept",
      },
    };
    const formData = new FormData();
    formData.append("project", JSON.stringify(updatedRow));
    SetisLoading(true);


    console.log("maindata", project._id, clickedServiceBreakdown, totalCostAllServices);
    const typeservicecost =
      serviceBreakdown[clickedServiceType]?.total || 0;
    const projectId = project._id;
    // const typeservicecost = clickedServiceBreakdown;
    const totaltypeservicecost = totalCostAllServices;
    console.log("maindata after", project._id, typeservicecost, totalCostAllServices);

    try {
      await dispatch(
        salespersonAcceptAction({
          projectId,
          typeservicecost,
          totaltypeservicecost,
        })
      ).unwrap();
      // await dispatch(salespersonAcceptProject({ projectId: project?._id }));
      enqueueSnackbar("Project Accepted Successfully", { variant: "success" });
      dispatch(fetchAllProjects());
    } catch (error) {
      console.error("Update error:", error);
      enqueueSnackbar("Update failed. See console for details.", {
        variant: "error",
      });
    } finally {
      handlerefresh();
      SetisLoading(false);
      // SetShowproject(false);
      setOpenInputReceived(openInputReceived === index ? null : index);
    }
    // setOpenProjectDropdown({ rowIndex: null, projectIndex: null });
  };

  const [operationclicked, setOperationclicked] = useState(false);
  const [hardwareEntries, setHardwareEntries] = useState([]);
  const [hardwarePartsEntries, setHardwarePartsEntries] = useState(null);
  console.log("hardwarePartsEntries", hardwarePartsEntries);
  const [Entries, setSelectedManagerEntries] = useState([]);
  const [managerDescriptions, setManagerDescriptions] = useState([]);

  /** Installation Response Received: hide template lines with no saved Amount (`value`). */
  const filterInstallationSavedOtherExpenseRows = (descriptions, project) =>
    filterInstallationOngoingOtherExpenseDisplayRows(
      descriptions || [],
      { TypeService: project?.TypeService }
    );

  const dedupeTrainingCostDescriptions = (list = []) => {
    if (!Array.isArray(list) || list.length === 0) return [];

    return consolidateTrainingExpenseRowsForDisplay(list);
  };

  /** Round hours to 2 decimals (fixes float display like 24.419999999999998 → 24.42). */
  const formatResponseHours = (value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) return "";
    const rounded = Math.round((numericValue + Number.EPSILON) * 100) / 100;
    return rounded.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  /** When Description mixes several assignees, merge training rows only within each `taskownerid`. */
  const dedupeTrainingCostDescriptionsByTaskOwner = (list = []) => {
    if (!Array.isArray(list) || list.length === 0) return [];
    const byOwner = new Map();
    for (const row of list) {
      const oid = normalizeDescriptionTaskOwnerId(row) || "__none__";
      if (!byOwner.has(oid)) byOwner.set(oid, []);
      byOwner.get(oid).push(row);
    }
    const out = [];
    byOwner.forEach((rows) => {
      out.push(...consolidateTrainingExpenseRowsForDisplay(rows));
    });
    return out;
  };

  /** Resolve description-task owner id when API nests ObjectId as an object. */
  const normalizeDescriptionTaskOwnerId = (row) => {
    const raw = row?.taskownerid;
    if (raw != null && typeof raw === "object") {
      return String(raw._id ?? raw.id ?? "").trim();
    }
    return String(raw ?? "").trim();
  };

  /** Prefer My Trainings–derived training row(s); drop persisted duplicate training lines when synthetic exists. */
  const mergeDescriptionTasksWithSyntheticTraining = (dedupedPersisted, syntheticTrainingRows) => {
    const synth = ([]).concat(syntheticTrainingRows || []).filter(Boolean);
    if (!synth.length) {
      return dedupeTrainingCostDescriptions(dedupedPersisted || []);
    }
    const manuals = ([]).concat(dedupedPersisted || []).filter((r) => !isTrainingExpenseDisplayRow(r));
    return dedupeTrainingCostDescriptions([...manuals, ...synth]);
  };

  const getTrainingDescriptionEntriesForProject = useCallback((project, assigneeIdOrEmail) => {
    if (!project || !assigneeIdOrEmail) return [];

    const list = Array.isArray(mytrainings?.trainings)
      ? mytrainings.trainings
      : Array.isArray(mytrainings)
        ? mytrainings
        : [];

    const resolveRefId = (ref) => {
      if (ref == null || ref === "") return "";
      if (typeof ref === "object") return String(ref?._id ?? ref?.id ?? "").trim();
      return String(ref).trim();
    };
    const normKey = (v) => String(v || "").trim().toLowerCase();
    const pick = (obj, keys) => {
      for (const k of keys) {
        const val = obj?.[k];
        if (val != null && String(val).trim() !== "") return val;
      }
      return "";
    };

    const projectLeadLike = project?.lead || project?.Lead || null;
    const projectIdCandidates = new Set(
      [
        resolveRefId(pick(project, ["_id", "id"])),
        resolveRefId(pick(project, ["projectid", "projectId", "ProjectId"])),
        resolveRefId(pick(projectLeadLike, ["_id", "id"])),
      ]
        .map((x) => normKey(x))
        .filter(Boolean)
    );
    const quotationIdCandidates = new Set(
      [
        pick(project, ["quotationId", "quotationID", "quotationid", "QuotationId", "QuotationID"]),
        pick(projectLeadLike, ["quotationId", "quotationID", "quotationid", "QuotationId", "QuotationID"]),
      ]
        .map((x) => String(x || "").trim())
        .filter(Boolean)
    );
    const projectNameCandidates = new Set(
      [
        pick(project, ["ProjectName", "projectname"]),
        pick(projectLeadLike, ["ProjectName", "projectname"]),
      ]
        .map((x) => normKey(x))
        .filter(Boolean)
    );
    const leadIdCandidates = new Set(
      [
        pick(project, ["leadid", "leadId", "LeadId", "LeadID"]),
        pick(projectLeadLike, ["leadid", "leadId", "LeadId", "LeadID"]),
        resolveRefId(pick(project, ["_id", "id"])),
      ]
        .map((x) => String(x || "").trim())
        .filter(Boolean)
    );

    const assigneeEmail = String(assigneeIdOrEmail || "").trim().toLowerCase();
    const assigneeId = resolveRefId(assigneeIdOrEmail);

    const matched = list
      .filter((t) => {
        const assignedToRaw = t?.assignedto ?? t?.assignedTo;
        const assignedToId = resolveRefId(assignedToRaw);
        const assignedToEmail =
          typeof assignedToRaw === "string" ? String(assignedToRaw).trim().toLowerCase() : "";
        const matchesAssignee =
          (assigneeId && assignedToId && assignedToId === assigneeId) ||
          (assigneeEmail && assignedToEmail && assignedToEmail === assigneeEmail);
        if (!matchesAssignee) return false;

        const tProjectId = normKey(resolveRefId(t?.projectid ?? t?.projectId ?? t?.project));
        const tQuotationId = String(t?.quotationId ?? t?.quotationID ?? t?.quotationid ?? "").trim();
        const tProjectName = normKey(t?.projectname);
        const tLeadId = String(t?.leadid ?? t?.leadId ?? "").trim();

        return (
          (tProjectId && projectIdCandidates.has(tProjectId)) ||
          (tQuotationId && quotationIdCandidates.has(tQuotationId)) ||
          (tProjectName && projectNameCandidates.has(tProjectName)) ||
          (tLeadId && leadIdCandidates.has(tLeadId))
        );
      });

    const normalized = matched.map((t) => {
        const amount = Number(
          String(t?.trainingcost ?? t?.trainingCost ?? 0)
            .toString()
            .replace(/,/g, "")
        );
        const notes = t?.notes ?? t?.note ?? "";
        return {
          amount: Number.isFinite(amount) ? amount : 0,
          notes: String(notes || "").trim(),
        };
      });

    const total = normalized.reduce((sum, x) => sum + (Number(x.amount) || 0), 0);
    const joinedNotes = Array.from(new Set(normalized.map((x) => x.notes).filter(Boolean))).join("; ");
    if (total <= 0 && !joinedNotes) return [];

    return [
      {
        _id: `training_cost_${assigneeId || assigneeEmail}`,
        taskownerid: assigneeId || assigneeEmail,
        description: "Training Cost",
        value: total,
        notes: joinedNotes,
      },
    ];
  }, [mytrainings]);

  const getManagerEntries = (project) => {
    // const isHardware = project.TypeService === "Hardware";
    const isHardware = project?.TypeService?.toLowerCase().includes("hardware");
    const foundEmployee = employees.find(
      (emp) => emp.EmpEmail === project.AssignedManagerEmail[0]
    );

    // Match entries by project ID
    const matchedEntries =
      entries?.filter(
        (entry) =>
          entry.projectid === project._id &&
          entry.taskownerid === foundEmployee?._id
      ) || [];

    // For hardware projects, get hardware-related entries from `items`
    const matchedEntriesHardware = isHardware
      ? items?.filter(
        (entry) =>
          entry.projectid === project._id
        // &&  entry.taskownerid === foundEmployee?._id
      ) || []
      : [];

    const matchedHardwareDescriptionsRaw =
      tasks?.filter(
        (entry) =>
          entry.projectid === project._id &&
          entry.taskownerid === foundEmployee?._id
      ) || [];
    const matchedHardwareDescriptions = dedupeTrainingCostDescriptions(
      matchedHardwareDescriptionsRaw
    );

    // Get assigned manager
    const currentEmployee = employees.find((emp) =>
      project.AssignedManagerEmail.includes(emp.EmpEmail)
    );

    const uniqueByPartDescription = Object.values(
      matchedEntriesHardware.reduce((acc, item) => {
        const key = item.assemblepartdescription?.toLowerCase();

        // if not present OR current quantity is higher → replace
        if (!acc[key] || item.quantity > acc[key].quantity) {
          acc[key] = item;
        }

        return acc;
      }, {})
    );


    if (!currentEmployee) {
      return {
        managerEntries: [],
        hardwareEntries: uniqueByPartDescription,
      };
    }

    const managerEntries = matchedEntries.filter(
      (entry) => entry.taskownerid === currentEmployee._id
    );
    const managerDescription = filterInstallationSavedOtherExpenseRows(
      matchedHardwareDescriptions.filter(
        (entry) => entry.taskownerid === currentEmployee._id
      ),
      project
    );
    const trainingDescriptions = getTrainingDescriptionEntriesForProject(
      project,
      currentEmployee._id
    );

    return {
      managerEntries,
      hardwareEntries: matchedEntriesHardware,
      managerDescription: mergeDescriptionTasksWithSyntheticTraining(
        managerDescription,
        trainingDescriptions
      ),
    };
  };

  const getEntriesManager = (project) => {
    const { managerEntries, hardwareEntries } = getManagerEntries(project); // ✅ correctly extract array

    // if (project.TypeService === "Hardware") {
    //   return hardwareEntries.length;
    // }
    const uniqueByPartDescription = Object.values(
      hardwareEntries.reduce((acc, item) => {
        const key = item.assemblepartdescription?.toLowerCase();

        // if not present OR current quantity is higher → replace
        if (!acc[key] || item.quantity > acc[key].quantity) {
          acc[key] = item;
        }

        return acc;
      }, {})
    );
    if (project?.TypeService?.toLowerCase().includes("hardware")) {
      return uniqueByPartDescription.length === 0
        ? " "
        : `${uniqueByPartDescription.length} Parts`;
    }
    const totalHours = managerEntries.reduce(
      (sum, entry) => sum + (entry.hoursassigned || 0),
      0
    );
    return totalHours === 0 ? " " : `${formatResponseHours(totalHours)} Hrs`;
  };

  /** Per-person column: sum of added other-expense lines only (no installation perdiem/avg cost). */
  const sumAddedOtherExpenseLines = (descriptions) =>
    (Array.isArray(descriptions) ? descriptions : []).reduce(
      (sum, desc) => sum + parseAmountNumber(desc?.value),
      0
    );

  const getOtherExpenseManager = (project) => {
    const { managerDescription } = getManagerEntries(project);
    const sumOfManagerDescription = sumAddedOtherExpenseLines(managerDescription);

    return sumOfManagerDescription === 0
      ? " "
      : ` ${formatAmountComma(sumOfManagerDescription)}`;
  };

  const getConsolidatedDataEntries = (project) => {

    const isHardware = project?.TypeService?.toLowerCase().includes("hardware");

    const matchedEntries =
      entries?.filter(
        (entry) =>
          entry.projectid === project?._id) || [];

    const operationDescriptionRaw =
      tasks?.filter(
        (entry) =>
          entry.projectid === project?._id
      ) || [];
    const operationDescription = filterInstallationSavedOtherExpenseRows(
      dedupeTrainingCostDescriptions(operationDescriptionRaw),
      project
    );

    const matchedHardwareEntries = isHardware
      ? items?.filter(
        (entry) =>
          entry.projectid === project?._id
      ) || []
      : [];

    const uniqueByPartDescription = Object.values(
      matchedHardwareEntries.reduce((acc, item) => {
        const key = item.assemblepartdescription;

        // if not present OR current quantity is higher → replace
        if (!acc[key] || item.quantity > acc[key].quantity) {
          acc[key] = item;
        }

        return acc;
      }, {})
    );


    return {
      operationEntries: matchedEntries,
      hardwareEntries: uniqueByPartDescription,
      operationDescription,
    };
  };

  const getOperationEntries = (project, OpPerson) => {
    let currentOPEmployee = null;

    if (
      OpPerson.salespersonstatus === "response received" &&
      OpPerson.taskStatus === "submit"
    ) {
      currentOPEmployee = employees.find(
        (emp) => emp.EmpEmail === OpPerson.email
      );
    }

    // const isHardware = project.TypeService === "Hardware";
    const isHardware = project?.TypeService?.toLowerCase().includes("hardware");

    const matchedEntries =
      entries?.filter(
        (entry) =>
          entry.projectid === project?._id &&
          entry.taskownerid === currentOPEmployee?._id
      ) || [];

    const operationDescriptionRaw =
      tasks?.filter(
        (entry) =>
          entry.projectid === project?._id &&
          entry.taskownerid === currentOPEmployee?._id
      ) || [];
    const operationDescription = filterInstallationSavedOtherExpenseRows(
      dedupeTrainingCostDescriptions(operationDescriptionRaw),
      project
    );

    const trainingSynthetic = getTrainingDescriptionEntriesForProject(
      project,
      currentOPEmployee?._id
    );

    const matchedHardwareEntries = isHardware
      ? items?.filter(
        (entry) =>
          entry.projectid === project?._id
        //  &&
        //   entry.taskownerid === currentOPEmployee?._id
      ) || []
      : [];

    const uniqueByPartDescription = Object.values(
      matchedHardwareEntries.reduce((acc, item) => {
        const key = item.assemblepartdescription;

        // if not present OR current quantity is higher → replace
        if (!acc[key] || item.quantity > acc[key].quantity) {
          acc[key] = item;
        }

        return acc;
      }, {})
    );


    return {
      operationEntries: matchedEntries,
      hardwareEntries: uniqueByPartDescription,
      operationDescription: mergeDescriptionTasksWithSyntheticTraining(
        operationDescription,
        trainingSynthetic
      ),
    };
  };

  const getEntriesOperation = (project, person) => {
    const { operationEntries, hardwareEntries } = getOperationEntries(
      project,
      person
    );

    // if (project.TypeService === "Hardware") {
    if (project?.TypeService?.toLowerCase().includes("hardware")) {
      return hardwareEntries.length;
    }

    const totalHours = operationEntries.reduce(
      (sum, entry) => sum + (entry.hoursassigned || 0),
      0
    );

    return totalHours === 0 ? 0 : formatResponseHours(totalHours);
  };

  const getOtherexpensesOperation = (project, person) => {
    const OtherexpenesOperation = getOperationEntries(project, person);
    const sumOfManagerDescription =
      OtherexpenesOperation.operationDescription?.reduce(
        (sum, item) => sum + parseAmountNumber(item.value),
        0
      );
    return sumOfManagerDescription === 0
      ? " "
      : ` ${formatAmountComma(sumOfManagerDescription)}`;
  };

  const [sortedProjects, setSortedProjects] = useState([]);

  useEffect(() => {
    setSortedProjects(projectsReceived);
  }, [projectsReceived]);

  const itemsPerPage = 10; // or any number of rows you want per page
  const [currentPage, setCurrentPage] = useState(1);

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
    filterLeadReports(query);
  };

  const totalItems = sortedProjects.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const paginatedProjects = sortedProjects.slice(startIdx, endIdx);

  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = projectsReceived.filter((LeadReport) =>
      Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value); // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }
        if (key === "groupid") {
          const groupName = getGroupDisplayName(LeadReport).toLowerCase();
          return groupName.includes(lowerCaseQuery);
        }
        // Handle all other fields
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      })
    );

    setSortedProjects(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    let sorted = [...sortedProjects]; // Always sort from the filtered dataset

    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };
    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) =>
          compareStrings(getGroupDisplayName(a), getGroupDisplayName(b))
        );
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) =>
          compareStrings(getGroupDisplayName(b), getGroupDisplayName(a))
        );
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // Default to original filtered order
        sorted = [...sortedProjects];
        break;
    }

    setSortedProjects(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  const [showActionToAssign, setShowActionToAssign] = useState({
    0: "tasktable",
  });

  // const MoveToOutstanding = async (row) => {
  //   SetisLoading(true);
  //   try {
  //     await dispatch(moveProjectToOutstanding(row.ProjectName))
  //     enqueueSnackbar("Project Moved to Request Outstanding Successfully", { variant: "success" });
  //   } catch (error) {
  //     console.error("Update error:", error);
  //     enqueueSnackbar("Update failed. See console for details.", {
  //       variant: "error",
  //     });
  //   } finally {
  //     SetisLoading(false);
  //     dispatch(fetchAllProjects());

  //   }
  // };

  // const parseCurrency = (value) => {
  //   if (typeof value === "string") {
  //     return Number(value.replace(/[^0-9.-]+/g, "")) || 0;
  //   }
  //   return Number(value) || 0;
  // };

  // const getAllExpensesTotal = (project) => {
  //   const managerExpenses = parseCurrency(getOtherExpenseManager(project));

  //   // Calculate operation expenses
  //   let operationExpenses = 0;
  //   const managerEmails =
  //     project.AssignedManagerEmail?.map(email => email?.trim().toLowerCase()) || [];

  //   const validPersons =
  //     project.Assignedperson?.filter(person => {
  //       const personEmail = person.email?.trim().toLowerCase();
  //       return (
  //         personEmail &&
  //         !managerEmails.includes(personEmail) &&
  //         (person.salespersonstatus === "response received" ||
  //           person.salespersonstatus === "submit")
  //       );
  //     }) || [];

  //   validPersons.forEach(person => {
  //     operationExpenses += parseCurrency(getOtherexpensesOperation(project, person));
  //   });
  //   const totalExpenses = managerExpenses + operationExpenses;
  //   return totalExpenses;
  // };

  const getAllHoursTotal = (project) => {
    const assignedEmails =
      project.Assignedperson?.map((person) =>
        person.email?.trim().toLowerCase()
      ) || [];

    const matchingEmployees = employees?.filter((employee) => {
      const employeeEmail = employee.EmpEmail?.trim().toLowerCase();
      return assignedEmails.includes(employeeEmail);
    });

    const matchingEmployeeIds = matchingEmployees?.map(
      (employee) => employee._id
    );

    const filteredWorkEntries = entries?.filter((entry) => {
      return (
        matchingEmployeeIds?.includes(entry.taskownerid) &&
        entry.projectid === project._id
      );
    });
    const totalHours = filteredWorkEntries.reduce((sum, entry) => {
      return sum + (entry.hoursassigned || 0);
    }, 0);

    const filteredHardwareEntries = items?.filter((entry) => {
      return (
        matchingEmployeeIds?.includes(entry.taskownerid) &&
        entry.projectid === project._id
      );
    });

    const uniqueHardwareEntries = filteredHardwareEntries?.filter(
      (entry, index, array) => {
        const firstIndex = array.findIndex(
          (item) =>
            item.assemblepartdescription === entry.assemblepartdescription
        );
        return index === firstIndex;
      }
    );

    if (project.TypeService?.toLowerCase().includes("hardware")) {
      return uniqueHardwareEntries.length;
    }
    return totalHours === 0 ? 0 : formatResponseHours(totalHours);
  };
  const [financeDataProject, setfinanceDataProject] = useState([]);
  useEffect(() => {
    const filteredProject = projects.filter(
      (proj) => proj.isProjecttracking === false
    );

    const qualifiedGroups = filteredProject.filter((project) => {
      // Must have at least one assigned person
      if (!project?.Assignedperson?.length) return false;

      // At least ONE assigned person must meet criteria
      return project.Assignedperson.some(
        (person) => person.salespersonstatus === "response received"
        // person.salespersonstatus === "project approved" || person.salespersonstatus === "project not-approved" ||
        // person.salespersonstatus === "project assigned" || person.salespersonstatus === "project not-assigned" ||
        // person.salespersonstatus === "project ongoing" ||
        // person.salespersonstatus === "project complete"
      );
    });
    setfinanceDataProject(qualifiedGroups);
  }, [projects]);

  const [searchedCalcProjects, setSearchedCalcProjects] = useState([]);

  useEffect(() => {
    if (!searchedLeadReports || !financeDataProject) return; // guard
    const matchedProjects = financeDataProject.filter((row) =>
      searchedLeadReports.some((proj) =>
        (proj.quotationId != null && row.quotationId != null)
          ? String(proj.quotationId) === String(row.quotationId)
          : proj.ProjectName === row.ProjectName
      )
    );
    setSearchedCalcProjects(matchedProjects);
  }, [searchedLeadReports, financeDataProject]);
  const [mergedProjects, setMergedProjects] = useState([]);

  useEffect(() => {
    if (!searchedCalcProjects || !tasks || !entries) return;

    const newData = searchedCalcProjects.map((proj) => {
      const matchedEntries = entries.filter(
        (entry) => entry.projectid === proj._id
      );

      const matchedDescriptions = tasks.filter(
        (task) => task.projectid === proj._id
      );
      const matchedHardware = items.filter(
        (task) => task.projectid === proj._id
      );

      return {
        ProjectName: proj.ProjectName,
        ProjectID: proj._id,
        TaskList: matchedEntries,
        Description: matchedDescriptions,
        TypeService: proj.TypeService,
        HardwareList: matchedHardware,
        Assignedperson: proj.Assignedperson,
        AssignedManagerEmail: proj.AssignedManagerEmail[0],
        SalesPersonEmail: proj.SalesPersonEmail,

      };
    });

    // const grouped = Object.values(
    //   newData.reduce((acc, project) => {
    //     if (!acc[project.ProjectName]) {
    //       acc[project.ProjectName] = {
    //         ProjectName: project.ProjectName,
    //         projects: [], // hold all occurrences
    //       };
    //     }
    //     acc[project.ProjectName].projects.push(project);
    //     return acc;
    //   }, {})
    // );

    setMergedProjects(newData);
  }, [searchedCalcProjects, tasks, entries, items]);

  const [combinedProjects, setCombinedProjects] = useState([]);

  // useEffect(() => {
  //   if (!mergedProjects || mergedProjects.length === 0) return;

  //   const grouped = Object.values(
  //     mergedProjects.reduce((acc, project) => {
  //       if (!acc[project.ProjectName]) {
  //         acc[project.ProjectName] = {
  //           ProjectName: project.ProjectName,
  //           TaskList: [],
  //           Description: [],
  //           HardwareList: [],
  //           // Assignedperson: [],
  //           // TypeService: [], // keep if needed
  //         };
  //       }

  //       acc[project.ProjectName].TaskList.push(...(project.TaskList || []));
  //       acc[project.ProjectName].Description.push(
  //         ...(project.Description || [])
  //       );
  //       acc[project.ProjectName].HardwareList.push(
  //         ...(project.HardwareList || [])
  //       );
  //       // acc[project.ProjectName].Assignedperson.push(...(project.Assignedperson || []));
  //       // if (project.TypeService) {
  //       //   acc[project.ProjectName].TypeService.push(project.TypeService);
  //       // }

  //       return acc;
  //     }, {})
  //   );

  //   setCombinedProjects(grouped);
  // }, [mergedProjects]);

  useEffect(() => {
    if (!mergedProjects || mergedProjects.length === 0) return;

    const grouped = Object.values(
      mergedProjects.reduce((acc, project) => {
        if (!acc[project.ProjectName]) {
          acc[project.ProjectName] = {
            ProjectName: project.ProjectName,
            projects: [], // Array to hold all projects with this name
          };
        }

        // Push the entire project object as-is to the projects array
        acc[project.ProjectName].projects.push({
          ProjectID: project.ProjectID,
          TypeService: project.TypeService,
          AssignedManagerEmail: project.AssignedManagerEmail,
          salespersonEmail: project.SalesPersonEmail,
          Assignedperson: project.Assignedperson || [],
          Description: project.Description || [],
          HardwareList: project.HardwareList || [],
          TaskList: project.TaskList || [],
          // Add any other fields you need
        });

        return acc;
      }, {})
    );

    setCombinedProjects(grouped);
  }, [mergedProjects]);

  const [groupedProjects, setGroupedProjects] = useState([]);

  // useEffect(() => {
  //   if (!combinedProjects || !employees) return;
  //   const updatedProjects = combinedProjects.map((project) => {
  //     // helper to map arrays
  //     const enrichWithDesignation = (arr) =>
  //       arr.map((item) => {
  //         const emp = employees.find(
  //           (e) => e._id === item.taskownerid || e._id === item.createdBy
  //         );
  //         if (emp) {
  //           return {
  //             ...item,
  //             designation: `${emp.servicetype || ""} ${emp.customRoles?.[0] || ""
  //               }`.trim(),
  //           };
  //         }
  //         return item;
  //       });

  //     return {
  //       ...project,
  //       Description: project.Description
  //         ? enrichWithDesignation(project.Description)
  //         : [],
  //       TaskList: project.TaskList
  //         ? enrichWithDesignation(project.TaskList)
  //         : [],
  //       HardwareList: project.HardwareList
  //         ? enrichWithDesignation(project.HardwareList)
  //         : [],
  //     };
  //   });

  //   setGroupedProjects(updatedProjects);
  // }, [combinedProjects, employees]);
  useEffect(() => {
    if (!combinedProjects || !employees) return;

    console.log("getHourlyRate combinedProjects", combinedProjects)


    const updatedProjects = combinedProjects.map((group) => {
      // Process each project in the group
      const updatedGroupProjects = group.projects.map((project) => {
        // helper to map arrays
        const enrichWithDesignation = (arr) =>
          arr.map((item) => {
            const emp = employees.find((e) => e._id === item.taskownerid);
            if (!emp) return item;

            // Prefer the project's service type for quoting (e.g. Installation Manager),
            // otherwise we can end up with "Hardware Manager" on an Installation project,
            // which makes hourly rate lookup return 0 and total = other expenses only.
            const serviceFromItem = String(item?.typeservice || "").trim();
            const serviceFromProject = String(project?.TypeService || "").trim();
            const service =
              serviceFromItem ||
              serviceFromProject ||
              String(emp?.servicetype || "").trim();

            return {
              ...item,
              designation: `${service} ${emp.customRoles?.[0] || ""}`.trim(),
            };
          });

        return {
          ...project,
          Description: project.Description
            ? enrichWithDesignation(project.Description)
            : [],
          TaskList: project.TaskList
            ? enrichWithDesignation(project.TaskList)
            : [],
          HardwareList: project.HardwareList
            ? enrichWithDesignation(project.HardwareList)
            : [],
        };
      });

      return {
        ...group,
        projects: updatedGroupProjects,
      };
    });

    setGroupedProjects(updatedProjects);
  }, [combinedProjects, employees]);

  const [quotationProjects, setquotationProjects] = useState([]);

  useEffect(() => {
    if (!groupedProjects || !hourlyRateData) return;

    const updatedProjects = groupedProjects.map((projectGroup) => {
      // Process each project within the group
      const updatedProjectsInGroup = projectGroup.projects.map((project) => {
        const assignedEmployee = employees.find(
          (emp) => emp.EmpEmail === project.salespersonEmail
        );

        console.log("assignedEmployee assignedEmployee", assignedEmployee);

        // helper to map arrays and add hourlysalary
        const enrichWithQuotation = (arr) =>
          arr.map((item) => {
            if (!item.designation) return item;
            const matchedQuote = hourlyRateData.find(
              (q) =>
                q.designation === item.designation
              // &&
              //   q.createdBy === assignedEmployee?._id
            );

            if (matchedQuote) {
              return {
                ...item,
                hourlysalary:
                  (matchedQuote.hourlysalaray || 0) +
                  (matchedQuote.overheadpercentage || 0),
              };
            }
            return item;
          });

        return {
          ...project,
          TaskList: project.TaskList
            ? enrichWithQuotation(project.TaskList)
            : [],
          Description: project.Description
            ? enrichWithQuotation(project.Description)
            : [],
          HardwareList: project.HardwareList
            ? enrichWithQuotation(project.HardwareList)
            : [],
        };
      });

      return {
        ...projectGroup,
        projects: updatedProjectsInGroup,
      };
    });

    setquotationProjects(updatedProjects);
  }, [groupedProjects, hourlyRateData, employees]);

  const [, setCalculatedProjects] = useState([]);

  useEffect(() => {
    if (!quotationProjects || quotationProjects.length === 0) return;

    const newData = quotationProjects.map((proj) => {
      let taskValue = 0;
      let descriptionValue = 0;
      let hardwareValue = 0;

      // ✅ TaskList calculation
      if (proj.TaskList?.length > 0) {
        const hoursByOwner = {};

        proj.TaskList.forEach((task) => {
          if (task.taskownerid && task.hoursassigned) {
            if (!hoursByOwner[task.taskownerid]) {
              hoursByOwner[task.taskownerid] = {
                totalHours: 0,
                hourlyRate: task.hourlysalaray || 0,
              };
            }
            hoursByOwner[task.taskownerid].totalHours += task.hoursassigned;
          }
        });

        Object.values(hoursByOwner).forEach((ownerData) => {
          taskValue += ownerData.totalHours * ownerData.hourlyRate;
        });
      }

      // ✅ Description calculation with Installation service condition
      if (proj.Description?.length > 0) {
        // Create a map to track trip duration per taskownerid for Installation services
        const installationTripByOwner = {};

        proj.Description.forEach((desc) => {
          // Skip hardware designations
          // if (desc.designation && desc.designation.toLowerCase().includes('hardware')) {
          //   return;
          // }

          // For Installation services, track trip duration per owner
          if (
            desc.typeservice &&
            desc.typeservice.toLowerCase().includes("installation") &&
            desc.taskownerid &&
            desc.tripduration
          ) {
            if (!installationTripByOwner[desc.taskownerid]) {
              installationTripByOwner[desc.taskownerid] = desc.tripduration;
            } else {
              // Use the maximum trip duration for each owner
              installationTripByOwner[desc.taskownerid] = Math.max(
                installationTripByOwner[desc.taskownerid],
                desc.tripduration
              );
            }
          }

          // Add the normal value calculation
          if (desc.value) {
            descriptionValue += desc.value;
          }
        });

        // Add Installation trip duration calculations (per diem + other expenses)
        Object.values(installationTripByOwner).forEach((tripDuration) => {
          // Assuming you have state variables called perdiem and otherExpense
          descriptionValue +=
            tripDuration * perdiem + tripDuration * averagecost;
        });
      }

      // ✅ HardwareList calculation
      if (proj.HardwareList?.length > 0) {
        proj.HardwareList.forEach((hw) => {
          if (hw.totalprice) {
            hardwareValue += hw.totalprice;
          }
        });
      }

      return {
        ProjectName: proj.ProjectName,
        TaskListValue: taskValue,
        DescriptionValue: descriptionValue,
        HardwareListValue: hardwareValue,
      };
    });

    setCalculatedProjects(newData);
  }, [quotationProjects, perdiem, averagecost]);

  // const getAllExpenses = (project) => {
  //   const matchedProjectfinal = quotationProjects.find(
  //     (proj) => proj.ProjectName === project.ProjectName
  //   )?.projects.find(
  //     (p) => p.ProjectID === project._id
  //   );
  //   const totalTaskValue = matchedProjectfinal?.TaskList.reduce((total, task) => {
  //     const hoursSpent = Number(task.hoursspent) || 0;
  //     const hourlySalary = Number(task.hourlysalaray) || 0;
  //     const overhead = Number(task.overheadpercentage) || 0;

  //     // ✅ Overhead is a direct addition, not a percentage
  //     const effectiveHourlySalary = hourlySalary + overhead;

  //     const taskValue = hoursSpent * effectiveHourlySalary;

  //     return total + taskValue;
  //   }, 0);

  //   let descriptionValue = 0;

  //   if (matchedProjectfinal.Description?.length > 0) {
  //     // Create a map to track trip duration per taskownerid for Installation services
  //     const installationTripByOwner = {};

  //     matchedProjectfinal.Description.forEach((desc) => {

  //       // For Installation services, track trip duration per owner
  //       if (desc.typeservice && desc.typeservice.toLowerCase().includes('installation') &&
  //         desc.taskownerid && desc.tripduration) {
  //         if (!installationTripByOwner[desc.taskownerid]) {
  //           installationTripByOwner[desc.taskownerid] = desc.tripduration;
  //         } else {
  //           // Use the maximum trip duration for each owner
  //           installationTripByOwner[desc.taskownerid] =
  //             Math.max(installationTripByOwner[desc.taskownerid], desc.tripduration);
  //         }
  //       }

  //       // Add the normal value calculation
  //       if (desc.expenses) {
  //         descriptionValue += desc.expenses;
  //       }
  //     });

  //     // Add Installation trip duration calculations (per diem + other expenses)
  //     Object.values(installationTripByOwner).forEach((tripDuration) => {
  //       // Assuming you have state variables called perdiem and otherExpense
  //       descriptionValue += (tripDuration * perdiem) + (tripDuration * averagecost);
  //     });
  //   }
  //   let hardwareValue = 0;
  //   if (matchedProjectfinal.HardwareList?.length > 0) {
  //     matchedProjectfinal.HardwareList.forEach((hw) => {
  //       if (hw.totalprice) {
  //         hardwareValue += hw.totalprice;
  //       }
  //     });
  //   }

  //   const grandTotal = totalTaskValue + descriptionValue + hardwareValue;

  //   return grandTotal;
  // };

  const getAllExpenses = (project) => {
    const matchedProjectfinal = quotationProjects
      .find((proj) => proj.ProjectName === project.ProjectName)
      ?.projects.find((p) => p.ProjectID === project._id);
    if (!matchedProjectfinal) return 0;

    const roundAmount2 = (n) =>
      Math.round((parseAmountNumber(n) + Number.EPSILON) * 100) / 100;

    const resolveTaskHourlyRate = (entry) => {
      if (!entry) return 0;
      if (entry.hourlysalary !== undefined && entry.hourlysalary !== null) {
        return parseFloat(entry.hourlysalary) || 0;
      }
      const hourlySalary = parseFloat(entry.hourlysalaray) || 0;
      const overhead = parseFloat(entry.overheadpercentage) || 0;
      return hourlySalary + overhead;
    };

    const getHourlyRateForEmail = (email) => {
      const employee = employees?.find((emp) => emp.EmpEmail === email);
      if (!employee) return 0;
      const taskEntry = matchedProjectfinal.TaskList?.find(
        (task) => task.taskownerid === employee._id
      );
      if (taskEntry) return resolveTaskHourlyRate(taskEntry);
      const descEntry = matchedProjectfinal.Description?.find(
        (desc) => desc.taskownerid === employee._id
      );
      if (descEntry) return resolveTaskHourlyRate(descEntry);
      const hwEntry = matchedProjectfinal.HardwareList?.find(
        (hw) => hw.taskownerid === employee._id
      );
      if (hwEntry) return resolveTaskHourlyRate(hwEntry);
      return 0;
    };

    const getTotalHoursForEmail = (email) => {
      const employee = employees?.find((emp) => emp.EmpEmail === email);
      if (!employee) return 0;
      return (
        matchedProjectfinal.TaskList?.filter(
          (task) => task.taskownerid === employee._id
        ).reduce(
          (sum, task) => sum + (parseFloat(task.hoursassigned) || 0),
          0
        ) || 0
      );
    };

    const getOtherExpensesForEmail = (email) => {
      const employee = employees?.find((emp) => emp.EmpEmail === email);
      if (!employee) return 0;

      let employeeDescriptions =
        matchedProjectfinal.Description?.filter(
          (desc) => desc.taskownerid === employee._id
        ) || [];

      const hasTraining = employeeDescriptions.some((d) =>
        isTrainingExpenseDisplayRow(d)
      );
      if (!hasTraining) {
        const trainingRows = getTrainingDescriptionEntriesForProject(
          project,
          employee._id
        );
        employeeDescriptions = dedupeTrainingCostDescriptionsByTaskOwner([
          ...employeeDescriptions,
          ...trainingRows,
        ]);
      }

      if (employeeDescriptions.length === 0) return 0;

      const totalValue = employeeDescriptions.reduce(
        (sum, desc) => sum + parseAmountNumber(desc.value),
        0
      );

      const firstDescription = employeeDescriptions[0];
      let tripExpenses = 0;
      if (
        firstDescription?.typeservice &&
        firstDescription.typeservice.toLowerCase().includes("installation") &&
        firstDescription.tripduration
      ) {
        const tripDuration = Number(firstDescription.tripduration) || 0;
        tripExpenses =
          tripDuration * (Number(perdiem) || 0) +
          tripDuration * (Number(averagecost) || 0);
      }
      return totalValue + tripExpenses;
    };

    const isPersonManager = (email) => {
      const employee = employees?.find((emp) => emp.EmpEmail === email);
      if (!employee) return false;
      const rawRole =
        employee.customRoles?.length > 0
          ? String(employee.customRoles[0] || "")
          : String(employee.EmpAuthLevel || "");
      return rawRole.toLowerCase().includes("manager");
    };

    const getMaxCommonHardwareTotal = () => {
      if (!matchedProjectfinal.HardwareList?.length) return 0;
      const grouped = matchedProjectfinal.HardwareList.reduce((acc, item) => {
        const key = item.assemblepartdescription;
        if (!acc[key]) acc[key] = [];
        acc[key].push(item);
        return acc;
      }, {});
      let total = 0;
      Object.values(grouped).forEach((items) => {
        const maxItem = items.reduce(
          (max, curr) => (curr.totalprice > max.totalprice ? curr : max),
          items[0]
        );
        total += maxItem.totalprice || 0;
      });
      return total;
    };

    const assignedPersons = matchedProjectfinal.Assignedperson || [];
    const isHardware = matchedProjectfinal.TypeService === "Hardware";
    const maxHardwareTotal = getMaxCommonHardwareTotal();

    return assignedPersons.reduce((totalExpensesSum, person) => {
      const otherExpenses = roundAmount2(getOtherExpensesForEmail(person.email));

      if (isHardware) {
        const manager = isPersonManager(person.email);
        const totalHardwarePrice = manager ? Math.round(maxHardwareTotal || 0) : 0;
        return totalExpensesSum + roundAmount2(totalHardwarePrice + otherExpenses);
      }

      const totalHours = parseFloat(getTotalHoursForEmail(person.email)) || 0;
      const hourlyRateNum = parseFloat(getHourlyRateForEmail(person.email)) || 0;
      return (
        totalExpensesSum +
        roundAmount2(hourlyRateNum * totalHours + otherExpenses)
      );
    }, 0);
  };

  const getExpensestableData = (project) => {
    const matchedProjectfinal = quotationProjects
      .find((proj) => proj.ProjectName === project.ProjectName)
      ?.projects.find((p) => p.ProjectID === project._id);
    setexpenseTableData(matchedProjectfinal);
  };

  const [ClickedEffort, setClickedEffort] = useState(null);
  const [hardwareClickedKey, setHardwareClickedKey] = useState(null);

  console.log("ClickedEffort", ClickedEffort);

  return (
    <>
      {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}
      <div className="pt-2">
        <div className="flex justify-between items-center p-2 bg-white rounded-t">
          <div className=" font-semibold">
            <h3>Response Received</h3>
          </div>
          <div className="flex w-60 gap-2 p-1 border border-[#e1e7ef] align-middle items-center rounded-md text-xs">
            <MdSearch className=" w-5 h-5 text-gray-500" />
            <input
              type="text"
              value={searchQuery}
              onChange={handleSearchInputChange}
              placeholder="Search"
              className="outline-none w-[80%]"
            />
          </div>
        </div>
        <div
          ref={responsereceiveddref}
          className="w-full overflow-auto bg-white h-full  min-h-[20vh] max-h-[90vh] "
        >
          <div className="">
            <div className="flex text-xs w-full text-center font-semibold rounded-t-md">
              <div className={` ${rowid ? "" : "w-[80%]"} `}>
                <div className={`flex `}>
                  <div className="w-14 p-2 bg-[#e8e8e8] rounded-tl-md  h-12 flex justify-start items-center align-middle">
                    Sr. No
                  </div>
                  <div
                    className={` ${rowid ? "w-28" : "w-[16.66%]"
                      } h-12  bg-[#e8e8e8]   p-2 break-words text-wrap flex justify-between items-center align-middle`}
                  >
                    Group
                    <div className="flex flex-col">
                      <div
                        className="cursor-pointer "
                        onClick={() =>
                          sortAlphabetically("AssignedGroup", "az")
                        }
                      >
                        <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                      </div>

                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() =>
                          sortAlphabetically("AssignedGroup", "za")
                        }
                      >
                        <ArrowDropDown
                          color="white"
                          sx={{ fontSize: "22px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${rowid ? "w-28" : "w-[16.66%]"
                      } h-12 bg-[#e8e8e8] p-2 break-words text-wrap flex justify-between items-center align-middle`}
                  >
                    Project
                    <div className="flex flex-col">
                      <div
                        className="cursor-pointer "
                        onClick={() => sortAlphabetically("ProjectName", "az")}
                      >
                        <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                      </div>

                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() => sortAlphabetically("ProjectName", "za")}
                      >
                        <ArrowDropDown
                          color="white"
                          sx={{ fontSize: "22px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${rowid ? "w-36" : "w-[18.66%]"
                      } h-12 relative   bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-center items-center align-middle`}
                  >
                    Date Requested
                    <div className="flex flex-col absolute right-1">
                      <div
                        className="cursor-pointer "
                        onClick={() =>
                          sortAlphabetically("DateRequested", "az")
                        }
                      >
                        <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                      </div>

                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() =>
                          sortAlphabetically("DateRequested", "za")
                        }
                      >
                        <ArrowDropDown
                          color="white"
                          sx={{ fontSize: "22px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${rowid ? "w-28" : "w-[16.66%]"
                      } h-12 relative bg-[#e8e8e8] p-2 break-words text-wrap flex justify-center items-center align-middle`}
                  >
                    Due Date
                    <div className=" flex flex-col absolute right-1">
                      <div
                        className="cursor-pointer "
                        onClick={() =>
                          sortAlphabetically("ProjectDueDate", "az")
                        }
                      >
                        <ArrowDropUp color="white" sx={{ fontSize: "22px" }} />
                      </div>

                      <div
                        className="cursor-pointer -mt-2"
                        onClick={() =>
                          sortAlphabetically("ProjectDueDate", "za")
                        }
                      >
                        <ArrowDropDown
                          color="white"
                          sx={{ fontSize: "22px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${rowid ? "w-28" : "w-[15.66%]"
                      } h-12  bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-around items-center align-middle`}
                  >
                    Attachment
                  </div>
                  <div
                    className={`${rowid ? "w-28" : "w-[15.66%]"
                      } h-12  bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-around items-center align-middle`}
                  >
                    Status
                  </div>
                </div>
              </div>
              {rowid ? (
                <div className="w-full">
                  <div className="flex ">
                    <div className="w-28 flex-shrink-0 h-12  bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-around items-center align-middle">
                      Manager Details
                    </div>
                    <div className="w-24 flex-shrink-0 h-12 bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-around items-center align-middle">
                      Hours/Parts
                    </div>
                    <div className="w-32 flex-shrink-0 h-12 bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-around items-center align-middle">
                      Other Expenses ({currency})
                    </div>
                    <div className="w-28 flex-shrink-0 h-12 bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-around items-center align-middle">
                      Employees
                    </div>
                    <div className="w-24 flex-shrink-0 h-12 bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-around items-center align-middle">
                      Hours/Parts
                    </div>
                    <div className="w-32 flex-shrink-0 h-12 bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-around items-center align-middle">
                      Other Expenses ({currency})
                    </div>
                    <div className="w-48 flex-shrink-0 h-12 bg-[#e8e8e8]  break-words text-wrap">
                      <div className="h-[50%] flex flex-col justify-around items-center align-middle border">
                        Total
                      </div>
                      <div className="flex h-[50%]">
                        <div className="w-[50%] flex  justify-around items-center align-middle border p-2">
                          Hours/Parts
                        </div>
                        <div className="w-[50%] flex  justify-around items-center align-middle border p-2">
                          Expenses ({currency})
                        </div>
                      </div>
                    </div>
                    <div className="w-32 rounded-tr-md flex-shrink-0 h-12 bg-[#e8e8e8]  p-2 break-words text-wrap flex justify-around items-center align-middle">
                      Action
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={`w-[20%]  h-12 rounded-tr-md  bg-[#e8e8e8] p-2 break-words text-wrap flex justify-center items-center align-middle`}
                >
                  Task Details
                </div>
              )}
            </div>
            <div className="w-full ">
              {paginatedProjects.map((row, index) => {
                const rowKey = row.quotationId ?? row.ProjectName ?? index;
                const isAccepted =
                  row?.Projects?.every((project) => {
                    return project?.Assignedperson?.every(
                      (person) => person?.salespersonaction === "accept"
                    );
                  }) || false;
                return (
                  <div
                    className={`flex text-xs w-full cursor-pointer ${row.isRead === false ? "font-bold" : " "
                      }`}
                    key={rowKey}
                  >
                    <div className={`flex ${rowid ? "" : "w-[80%]"}`}>
                      <div
                        onClick={() => {
                          setrowid((prev) =>
                            prev === rowKey ? null : rowKey
                          );
                          setSelected(!selected);
                        }}
                        className="w-14 p-2 border-b flex justify-start align-middle items-center"
                      >
                        {index + 1}
                      </div>
                      <div
                        onClick={() => {
                          setrowid((prev) =>
                            prev === rowKey ? null : rowKey
                          );
                          setSelected(!selected);
                        }}
                        className={`${rowid ? "w-28 flex-shrink-0" : "w-[16.66%]"
                          } border-b flex justify-start align-middle items-center  p-2 break-words text-wrap`}
                      >
                        {getGroupDisplayName(row)}
                      </div>
                      <div
                        onClick={() => {
                          setrowid((prev) =>
                            prev === rowKey ? null : rowKey
                          );
                          setSelected(!selected);
                        }}
                        className={`${rowid ? "w-28 flex-shrink-0" : "w-[16.66%]"
                          } border-b flex justify-start align-middle items-center text-left p-2 break-words whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs`}
                      >
                        {row.ProjectName}
                      </div>
                      <div
                        onClick={() => {
                          setrowid((prev) =>
                            prev === rowKey ? null : rowKey
                          );
                          setSelected(!selected);
                        }}
                        className={`${rowid ? "w-36 flex-shrink-0" : "w-[18.66%]"
                          } border-b flex justify-center align-middle items-center  p-2 break-words text-wrap`}
                      >
                        {row.DateRequested &&
                          !isNaN(new Date(row.DateRequested))
                          ? formatDateByCountry(row.DateRequested)
                          : ""}
                      </div>
                      <div
                        onClick={() => {
                          setrowid((prev) =>
                            prev === rowKey ? null : rowKey
                          );
                          setSelected(!selected);
                        }}
                        className={`${rowid ? "w-28 flex-shrink-0" : "w-[16.66%]"
                          } border-b flex justify-center align-middle items-center  p-2 break-words text-wrap`}
                      >
                        {row.ProjectDueDate &&
                          !isNaN(new Date(row.ProjectDueDate))
                          ? formatDateByCountry(row.ProjectDueDate)
                          : ""}
                      </div>
                      <div
                        className={`${rowid ? "w-28 flex-shrink-0" : "w-[15.66%]"
                          }  border-b p-2 text-center flex justify-center align-middle items-center break-words text-wrap`}
                      >
                        <AttachFileIcon
                          className="rotate-12 cursor-pointer"
                          onClick={() => {
                            setCurrentProject(row);
                            setShowAttach(true);
                          }}
                        />
                      </div>
                      <div
                        className={`${rowid ? "w-28 flex-shrink-0" : "w-[15.66%]"
                          }  border-b p-2 text-center flex justify-center align-middle items-center break-words text-wrap`}
                      >
                        <span
                          className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-medium
        ${isAccepted
                              ? "bg-green-50 text-green-600 border border-green-200"
                              : "bg-orange-50 text-orange-500 border border-orange-200"
                            }`}
                        >
                          <span
                            className={`w-2.5 h-2.5 rounded-full
          ${isAccepted ? "bg-green-500" : "bg-orange-400"}`}
                          />
                          {isAccepted ? "Accepted" : "Pending"}
                        </span>
                      </div>
                    </div>

                    {rowid === rowKey ? (
                      <div className="projetdetails ">
                        {row.Projects?.map((project, projectIndex) => {
                          const hardwareKey = `${projectIndex}-hardware-${project._id}`;
                          const otherExpensesKey = `project-${projectIndex}-${project._id}`;

                          // Support both key styles from API payloads.
                          const isProjectQuoted =
                            project?.isProjectQuoted === true ||
                            project?.isProjectQuoted === "true" ||
                            project?.isprojectquoted === true ||
                            project?.isprojectquoted === "true";
                          const hideRejectOption = isProjectQuoted;
                          return (
                            <div key={`project-wrapper-${projectIndex}`} className="border-b border-gray-300 pb-2">
                              <div
                                key={`project-${projectIndex}`}
                                className="flex"
                              >
                                <div className="flex ManagerRole">
                                  <div className="ManagerDetails  w-28 flex-shrink-0 ManagerName text-center break-words flex justify-center items-center">
                                    <div
                                      onClick={() => {
                                        const key = `manager_${index}_${projectIndex}`;

                                        const {
                                          managerEntries,
                                          hardwareEntries,
                                          managerDescription,
                                        } = getManagerEntries(project);
                                        console.log("hardwarePartsEntries1 ", hardwareEntries)
                                        setHardwareEntries(hardwareEntries);
                                        setManagerDescriptions(
                                          managerDescription
                                        );
                                        setSelectedManagerEntries(managerEntries); // ✅ store clicked manager's entries
                                        setActiveTaskKey((prevKey) =>
                                          prevKey === key ? null : key
                                        );
                                        setShowActionToAssign((prev) => ({
                                          ...prev,
                                          [index]: "tasktable", // Set to tasktable for hours
                                        }));
                                        setOperationclicked(false);
                                        setShowExpensesForProject(null);
                                        setClickedEffort(null)
                                        setHardwareClickedKey(null)
                                        setShowExpensesForProject(null)
                                      }}
                                      className={`
                                 ${activeTaskKey ===
                                          `manager_${index}_${projectIndex}`
                                          ? "text-blue-500 rounded-md  p-2"
                                          : ""
                                        }`}
                                    >
                                      {employees
                                        .filter((employee) =>
                                          project.AssignedManagerEmail?.includes(
                                            employee.EmpEmail
                                          )
                                        )
                                        .map((emp) => {
                                          const fullName =
                                            `${emp.EmpFirstName.charAt(
                                              0
                                            ).toUpperCase()}${emp.EmpFirstName.slice(
                                              1
                                            )} ` +
                                            `${emp.EmpLastName.charAt(
                                              0
                                            ).toUpperCase()}${emp.EmpLastName.slice(
                                              1
                                            )}`;

                                          const service = `(${emp.servicetype || ""
                                            }`;

                                          const role =
                                            emp.customRoles[0] ===
                                              "project manager"
                                              ? "Manager)"
                                              : "Employee)";

                                          return `${fullName} ${service} ${role}`;
                                        })
                                        .join(", ")}
                                    </div>
                                  </div>

                                  <div className="Hours/Parts flex justify-center items-center">
                                    <div
                                      onClick={() => {
                                        if (getEntriesManager(project) !== " ") {
                                          const key = `manager_${index}_${projectIndex}`;
                                          const {
                                            managerEntries,
                                            hardwareEntries,
                                            managerDescription,
                                          } = getManagerEntries(project);
                                          setHardwareEntries(hardwareEntries);
                                          setManagerDescriptions(
                                            managerDescription
                                          );
                                          setSelectedManagerEntries(
                                            managerEntries
                                          );
                                          setActiveTaskKey((prevKey) =>
                                            prevKey === key ? null : key
                                          );
                                          setShowActionToAssign((prev) => ({
                                            ...prev,
                                            [index]: "tasktable", // Set to tasktable for hours
                                          }));
                                          setOperationclicked(false);
                                          setShowExpensesForProject(null);
                                          setShowConsolidatedPartsProject(null);
                                          setHighlightedConsolidatedParts(null);
                                          setClickedEffort(null)
                                          setHardwareClickedKey(null)
                                        }
                                      }}
                                      className={`p-2 w-24 flex-shrink-0 h-full  Manager Hours flex items-center justify-center text-center break-words align-middle cursor-pointer
                                     ${activeTaskKey ===
                                          `manager_${index}_${projectIndex}` &&
                                          showActionToAssign[index] === "tasktable"
                                          ? "text-blue-500 rounded-md "
                                          : ""
                                        }`}
                                    >
                                      {getEntriesManager(project) === " "
                                        ? " "
                                        : getEntriesManager(project)}
                                    </div>
                                  </div>
                                  <div className="OtherExpenses flex justify-center items-center">
                                    <div
                                      onClick={() => {
                                        if (
                                          getOtherExpenseManager(project) !== " "
                                        ) {
                                          const key = `manager_${index}_${projectIndex}`;
                                          const {
                                            managerEntries,
                                            hardwareEntries,
                                            managerDescription,
                                          } = getManagerEntries(project);
                                          setHardwareEntries(hardwareEntries);
                                          setManagerDescriptions(
                                            managerDescription
                                          );
                                          setSelectedManagerEntries(
                                            managerEntries
                                          );
                                          setActiveTaskKey((prevKey) =>
                                            prevKey === key ? null : key
                                          );
                                          setShowActionToAssign((prev) => ({
                                            ...prev,
                                            [index]: "otherexpenses", // Set to otheexpenses for expenses
                                          }));
                                          setOperationclicked(false);
                                          setShowExpensesForProject(null);
                                          setShowConsolidatedPartsProject(null);
                                          setHighlightedConsolidatedParts(null);
                                          setClickedEffort(null)
                                          setHardwareClickedKey(null)
                                          setShowExpensesForProject(null)
                                        }
                                      }}
                                      className={`p-2 w-32 h-full OMothetexpenses break-words text-wrap flex justify-center items-center align-middle cursor-pointer
    ${activeTaskKey === `manager_${index}_${projectIndex}` &&
                                          showActionToAssign[index] === "otherexpenses"
                                          ? "text-blue-500 rounded-md "
                                          : ""
                                        }`}
                                    >
                                      {getOtherExpenseManager(project)}
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={`cursor-pointer  flex justify-center items-center`}
                                >
                                  {/* Team Member Role */}
                                  <div className="Employees w-28 flex-shrink-0 h-full  flex flex-col justify-center items-center">
                                    {(() => {
                                      const managerEmails =
                                        project.AssignedManagerEmail?.map(
                                          (email) => email?.trim().toLowerCase()
                                        ) || [];

                                      const validPersons =
                                        project.Assignedperson?.filter(
                                          (person) => {
                                            const personEmail = person.email
                                              ?.trim()
                                              .toLowerCase();
                                            return (
                                              personEmail &&
                                              !managerEmails.includes(
                                                personEmail
                                              ) &&
                                              (person.salespersonstatus ===
                                                "response received" ||
                                                person.salespersonstatus ===
                                                "submit")
                                            );
                                          }
                                        );

                                      return validPersons?.length ? (
                                        validPersons.map(
                                          (person, personIndex) => {
                                            const OpPerson = person;
                                            const employeeLabel =
                                              validPersons.length === 1
                                                ? `${project?.TypeService} Employee`
                                                : `${project?.TypeService
                                                } Employee ${personIndex + 1}`;

                                            return (
                                              <div
                                                key={`person-${personIndex}`}
                                                className={`break-words p-2 h-full w-full flex justify-center items-center text-center
                                          ${activeTaskKey ===
                                                    `operation_${index}_${projectIndex}_${personIndex}`
                                                    ? "text-blue-500 rounded-md "
                                                    : ""
                                                  }`}
                                                onClick={() => {
                                                  const key = `operation_${index}_${projectIndex}_${personIndex}`;
                                                  const {
                                                    hardwareEntries,
                                                    operationEntries,
                                                    operationDescription,
                                                  } = getOperationEntries(
                                                    project,
                                                    OpPerson
                                                  );
                                                  setSelectedManagerEntries(
                                                    operationEntries
                                                  );
                                                  setManagerDescriptions(
                                                    operationDescription
                                                  );
                                                  setHardwareEntries(
                                                    hardwareEntries
                                                  );
                                                  setActiveTaskKey((prevKey) =>
                                                    prevKey === key ? null : key
                                                  );
                                                  setShowActionToAssign(
                                                    (prev) => ({
                                                      ...prev,
                                                      [index]: "tasktable", // Set to tasktable for hours2
                                                    })
                                                  );
                                                  setOperationclicked(true);
                                                  setShowExpensesForProject(null);
                                                  setShowConsolidatedPartsProject(null);
                                                  setHighlightedConsolidatedParts(null);
                                                  setClickedEffort(null)
                                                  setHardwareClickedKey(null)
                                                }}
                                              >
                                                {employeeLabel}
                                              </div>
                                            );
                                          }
                                        )
                                      ) : (
                                        <div className="break-words text-center p-2 h-[10] "></div>
                                      );
                                    })()}
                                  </div>

                                  {/* Team Member Hours */}
                                  <div className="Parts w-24 flex-shrink-0  h-full  flex flex-col justify-center">
                                    {(() => {
                                      const managerEmails =
                                        project.AssignedManagerEmail?.map(
                                          (email) => email?.trim().toLowerCase()
                                        ) || [];

                                      const validPersons =
                                        project.Assignedperson?.filter(
                                          (person) => {
                                            const personEmail = person.email
                                              ?.trim()
                                              .toLowerCase();
                                            return (
                                              personEmail &&
                                              !managerEmails.includes(
                                                personEmail
                                              ) &&
                                              (person.salespersonstatus ===
                                                "response received" ||
                                                person.salespersonstatus ===
                                                "submit")
                                            );
                                          }
                                        );

                                      return validPersons?.length ? (
                                        validPersons.map(
                                          (person, personIndex) => {
                                            return (
                                              <div
                                                key={`hours-${personIndex}`}
                                                className={`break-words text-center p-2 flex justify-center items-center h-full w-full cursor-pointer ${activeTaskKey === `operation_${index}_${projectIndex}_${personIndex}` &&
                                                  showActionToAssign[index] === "tasktable"
                                                  ? "text-blue-500 rounded-md "
                                                  : ""
                                                  }`}
                                                onClick={() => {
                                                  const key = `operation_${index}_${projectIndex}_${personIndex}`;
                                                  const {
                                                    hardwareEntries,
                                                    operationEntries,
                                                    operationDescription,
                                                  } = getOperationEntries(
                                                    project,
                                                    person
                                                  );
                                                  setHardwareEntries(
                                                    hardwareEntries
                                                  );
                                                  setSelectedManagerEntries(
                                                    operationEntries
                                                  );
                                                  setManagerDescriptions(
                                                    operationDescription
                                                  );
                                                  setActiveTaskKey((prevKey) =>
                                                    prevKey === key ? null : key
                                                  );
                                                  setShowActionToAssign(
                                                    (prev) => ({
                                                      ...prev,
                                                      [index]: "tasktable", // Set to tasktable for hours
                                                    })
                                                  );
                                                  setOperationclicked(true);
                                                  setShowExpensesForProject(null);
                                                  setShowConsolidatedPartsProject(null);
                                                  setHighlightedConsolidatedParts(null);
                                                  setClickedEffort(null)
                                                  setHardwareClickedKey(null)
                                                  setShowExpensesForProject(null)
                                                }}
                                              >
                                                {getEntriesOperation(
                                                  project,
                                                  person
                                                )}{" "}
                                                {project?.TypeService?.toLowerCase().includes(
                                                  "hardware"
                                                )
                                                  ? "Parts"
                                                  : "Hrs"}
                                              </div>
                                            );
                                          }
                                        )
                                      ) : (
                                        <div className="break-words text-center p-2 h-[10] flex justify-center items-center"></div>
                                      );
                                    })()}
                                  </div>

                                  <div className="OtherExpenses OPothetexpenses h-full  w-32 flex-shrink-0 flex flex-col justify-center">
                                    {(() => {
                                      const managerEmails =
                                        project.AssignedManagerEmail?.map(
                                          (email) => email?.trim().toLowerCase()
                                        ) || [];
                                      const validPersons =
                                        project.Assignedperson?.filter(
                                          (person) => {
                                            const personEmail = person.email
                                              ?.trim()
                                              .toLowerCase();
                                            return (
                                              personEmail &&
                                              !managerEmails.includes(
                                                personEmail
                                              ) &&
                                              (person.salespersonstatus ===
                                                "response received" ||
                                                person.salespersonstatus ===
                                                "submit")
                                            );
                                          }
                                        );

                                      return validPersons?.length ? (
                                        validPersons.map(
                                          (person, personIndex) => {
                                            return (
                                              <div
                                                key={`expenses-${personIndex}`}
                                                className={`break-words text-center flex justify-center items-center h-full w-full cursor-pointer
    ${activeTaskKey === `operation_${index}_${projectIndex}_${personIndex}` &&
                                                    showActionToAssign[index] === "otherexpenses"
                                                    ? "text-blue-500 rounded-md"
                                                    : ""
                                                  }`}
                                                onClick={() => {
                                                  const key = `operation_${index}_${projectIndex}_${personIndex}`;
                                                  const {
                                                    hardwareEntries,
                                                    operationEntries,
                                                    operationDescription,
                                                  } = getOperationEntries(
                                                    project,
                                                    person
                                                  );
                                                  setHardwareEntries(
                                                    hardwareEntries
                                                  );
                                                  setSelectedManagerEntries(
                                                    operationEntries
                                                  );
                                                  setManagerDescriptions(
                                                    operationDescription
                                                  );
                                                  setActiveTaskKey((prevKey) =>
                                                    prevKey === key ? null : key
                                                  );
                                                  setShowActionToAssign(
                                                    (prev) => ({
                                                      ...prev,
                                                      [index]: "otherexpenses", // Set to otheexpenses for expenses
                                                    })
                                                  );
                                                  setOperationclicked(true);
                                                  setShowExpensesForProject(null);
                                                  setClickedEffort(null)
                                                  setHardwareClickedKey(null)
                                                  setShowExpensesForProject(null)
                                                }}
                                              >
                                                {getOtherexpensesOperation(
                                                  project,
                                                  person
                                                )}{" "}
                                              </div>
                                            );
                                          }
                                        )
                                      ) : (
                                        <div className="break-words text-center p-1 h-[10] flex justify-center items-center"></div>
                                      );
                                    })()}
                                  </div>
                                </div>

                                <div className="w-48 flex-shrink-0 ">
                                  <div className="flex h-full">
                                    {project?.TypeService?.toLowerCase().includes("hardware") ? (
                                      <div
                                        onClick={() => {
                                          setClickedEffort(null)
                                          const { hardwareEntries } = getConsolidatedDataEntries(project);
                                          setHardwarePartsEntries(hardwareEntries);
                                          if (hardwareClickedKey === hardwareKey) {
                                            setHardwareClickedKey(null)
                                          } else {
                                            setHardwareClickedKey(hardwareKey)
                                            setShowExpensesForProject(null)
                                          }
                                          if (ClickedEffort === `effort-${projectIndex}` || ClickedEffort === `other-${projectIndex}`) {
                                            setClickedEffort(null)
                                          }
                                          setActiveTaskKey(null);
                                        }}
                                        className={`allothetexpenses w-[50%] flex justify-around items-center align-middle p-2 cursor-pointer
                                     ${(hardwareClickedKey === hardwareKey)
                                            ? "text-blue-500"
                                            : ""
                                          }`}

                                      >
                                        {getAllHoursTotal(project)}
                                        {" Parts"}
                                      </div>
                                    ) : (
                                      <div
                                        onClick={() => {
                                          setHardwarePartsEntries([])
                                          getExpensestableData(project);
                                          if (ClickedEffort === `effort-${projectIndex}` || ClickedEffort === `other-${projectIndex}`) {
                                            setClickedEffort(null)
                                          } else {
                                            setClickedEffort(`effort-${projectIndex}`)
                                          }
                                          if (showExpensesForProject === otherExpensesKey) {
                                            setShowExpensesForProject(null)
                                          } else {
                                            setShowExpensesForProject(otherExpensesKey)
                                            setHardwareClickedKey(null)
                                          }
                                          setActiveTaskKey(null);
                                        }}
                                        className={`allothetexpenses w-[50%] flex justify-around items-center align-middle p-2 cursor-pointer
                                       ${(ClickedEffort === `effort-${projectIndex}`)
                                            ? "text-blue-500"
                                            : "text-black"
                                          }`}
                                      >
                                        {getAllHoursTotal(project)}{" Hrs"}

                                      </div>
                                    )}

                                    <div
                                      onClick={() => {
                                        getExpensestableData(project);
                                        if (ClickedEffort === `other-${projectIndex}` || ClickedEffort === `effort-${projectIndex}`) {
                                          setClickedEffort(null)
                                        } else {
                                          setClickedEffort(`other-${projectIndex}`)
                                        }
                                        if (showExpensesForProject === otherExpensesKey) {
                                          setShowExpensesForProject(null)
                                        } else {
                                          setShowExpensesForProject(otherExpensesKey)
                                          setHardwareClickedKey(null)

                                        }

                                        // if (
                                        //   showExpensesForProject === projectKey || ClickedEffort === `other-${projectIndex}`
                                        // ) {
                                        //   setShowExpensesForProject(null);
                                        //   setHighlightedExpenses(null);
                                        //   setShowConsolidatedPartsProject(null);
                                        //   setHighlightedConsolidatedParts(null);
                                        //   setClickedPartEffort(null)
                                        // } else {
                                        //   setShowExpensesForProject(projectKey);
                                        //   setHighlightedExpenses(projectKey);
                                        //   getExpensestableData(project);
                                        //   setClickedPartEffort(null)
                                        // }
                                        setActiveTaskKey(null);
                                      }}
                                      className={`allothetexpenses w-[50%]  flex justify-around items-center align-middle p-2 cursor-pointer
                                       ${(ClickedEffort === `other-${projectIndex}`) ? "text-blue-500 " : "text-black"
                                        }`}
                                    >
                                      {formatAmountComma(getAllExpenses(project))}
                                    </div>
                                  </div>
                                </div>

                                <div className="w-32 flex-shrink-0  flex justify-center items-center p-2 break-words text-wrap ">
                                  <div className="w-full ">
                                    <div className="bg-white">
                                      <div className="relative flex p-0 rounded-xl align-middle items-center">
                                        <select
                                          disabled={
                                            isViewOnly || project.SalesPersonAction === "reject"
                                          }
                                          value={
                                            probabilityList[index] ||
                                            (project.Assignedperson?.some(
                                              (p) =>
                                                p.salespersonaction === "accept"
                                            )
                                              ? "Accepted"
                                              : project.Assignedperson?.some(
                                                (p) =>
                                                  p.salespersonaction ===
                                                  "reject"
                                              )
                                                ? "Rejected"
                                                : "")
                                          }
                                          onChange={(e) => {
                                            if (isViewOnly) return;
                                            const selected = e.target.value;
                                            if (selected === "Accept") {
                                              handleAccept(
                                                row,
                                                project,
                                                index,
                                                "Accept"
                                              );
                                              // setSelectedProjectName(row);
                                              setActiveTaskKey(null);
                                              setShowExpensesForProject(null);
                                              setShowActionToAssign({});
                                            } else if (selected === "Reject") {
                                              handleReject(
                                                row,
                                                project,
                                                index,
                                                "Reject"
                                              );
                                              setActiveTaskKey(null);
                                              setShowExpensesForProject(null);
                                              setShowActionToAssign({});
                                            } else if (selected === "Cancel") {
                                              handleCancel(project);
                                              setActiveTaskKey(null);
                                              setShowExpensesForProject(null);
                                              setShowActionToAssign({});
                                            }

                                            // close any open dropdowns and reset
                                            // setOpenProjectDropdown({ rowIndex: null, projectIndex: null });
                                          }}
                                          className={`border statusbutton w-full bg-white border-gray-400 text-nowrap rounded-md p-2 shadow-md text-start overflow-hidden outline-none cursor-pointer ${isViewOnly ? "opacity-50 cursor-not-allowed" : ""}`}
                                        >
                                          {/* Default Option */}
                                          <option hidden value="">
                                            {project.Assignedperson?.some(
                                              (p) =>
                                                p.salespersonaction === "accept"
                                            )
                                              ? "Accepted"
                                              : project.Assignedperson?.some(
                                                (p) =>
                                                  p.salespersonaction ===
                                                  "reject"
                                              )
                                                ? "Rejected"
                                                : "Select Option"}
                                          </option>

                                          {/* Accept Option (only if not all accepted) */}
                                          {project.Assignedperson?.some(
                                            (p) =>
                                              p.salespersonaction !== "accept"
                                          ) && (
                                              <option value="Accept">
                                                {project.Assignedperson?.find(
                                                  (p) =>
                                                    p.name === row.assignpersonName
                                                )?.manageraction === "rejected" &&
                                                  project.Assignedperson?.find(
                                                    (p) =>
                                                      p.name === row.assignpersonName
                                                  )?.operationaction === "resubmit"
                                                  ? "Accept"
                                                  : "Accept"}
                                              </option>
                                            )}

                                          {/* Reject Option (only if not all rejected) */}
                                          {project.Assignedperson?.some(
                                            (p) =>
                                              p.salespersonaction !== "reject"
                                          ) && !hideRejectOption && (
                                              <option value="Reject">Reject</option>
                                            )}

                                          {/* Cancel Option (always available) */}
                                          <option value="Cancel">Cancel</option>
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {hardwareClickedKey === hardwareKey && (
                                <ConsolidatedHardware
                                  showActionToAssign={showActionToAssign}
                                  index={index}
                                  hardwareEntries={hardwarePartsEntries}
                                />
                              )}

                              {showExpensesForProject === otherExpensesKey && (
                                (() => {
                                  // Build Training Cost rows for every assignee (manager + operations),
                                  // so the summary table matches the per-person Other Expenses tables.
                                  const existingDesc = Array.isArray(expenseTableData?.Description)
                                    ? expenseTableData.Description
                                    : [];
                                  const hasTrainingForOwner = new Set(
                                    existingDesc
                                      .filter((d) => isTrainingExpenseDisplayRow(d))
                                      .map((d) => normalizeDescriptionTaskOwnerId(d))
                                      .filter(Boolean)
                                  );

                                  const trainingDescriptionsAll = (project?.Assignedperson || [])
                                    .flatMap((p) => {
                                      const email = String(p?.email || p?.EmpEmail || "").trim().toLowerCase();
                                      if (!email) return [];
                                      const emp = (employees || []).find(
                                        (e) =>
                                          String(e?.EmpEmail || "").trim().toLowerCase() === email
                                      );
                                      if (!emp?._id) return [];
                                      if (hasTrainingForOwner.has(String(emp._id))) return [];
                                      return getTrainingDescriptionEntriesForProject(project, emp._id);
                                    });

                                  const enhancedExpenseTableData = expenseTableData
                                    ? {
                                      ...expenseTableData,
                                      Description: dedupeTrainingCostDescriptionsByTaskOwner([
                                        ...existingDesc,
                                        ...trainingDescriptionsAll,
                                      ]),
                                    }
                                    : expenseTableData;
                                  return (
                                <QuotedExpenseTable
                                  expenseTableData={enhancedExpenseTableData}
                                  employeeData={employees}
                                  perdiem={perdiem}
                                  averagecost={averagecost}
                                  preserveDecimalHourlyRates={true}
                                />
                                  );
                                })()
                              )}

                              {/* {project.TypeService === "Hardware" */}
                              {project?.TypeService?.toLowerCase().includes(
                                "hardware"
                              )
                                ? (activeTaskKey ===
                                  `manager_${index}_${projectIndex}` ||
                                  activeTaskKey?.startsWith(
                                    `operation_${index}_${projectIndex}_`
                                  )) && (
                                  <div>
                                    <div
                                      className={`p-1  flex ${operationclicked
                                        ? "justify-center"
                                        : "justify-start"
                                        } gap-2`}
                                    >
                                      <div
                                        onClick={() =>
                                          setShowActionToAssign((prev) => ({
                                            ...prev,
                                            [index]: "tasktable",
                                          }))
                                        }
                                        className={`cursor-pointer py-2 px-4 inline-block border rounded-md text-start ${showActionToAssign[index] ===
                                          "tasktable"
                                          ? "bg-blue-500 text-white"
                                          : "bg-white"
                                          }`}
                                      >
                                        {/* {project.TypeService === "Hardware"
                                      ? "Part List"
                                      : "Effort Expenses"} */}
                                        {project?.TypeService?.toLowerCase().includes(
                                          "hardware"
                                        )
                                          ? "Part List"
                                          : "Effort Expenses"}
                                      </div>
                                      <div
                                        onClick={() =>
                                          setShowActionToAssign((prev) => ({
                                            ...prev,
                                            [index]: "otherexpenses",
                                          }))
                                        }
                                        className={`cursor-pointer py-2 px-4 inline-block border rounded-md text-start ${showActionToAssign[index] ===
                                          "otherexpenses"
                                          ? "bg-blue-500 text-white"
                                          : "bg-white"
                                          }`}
                                      >
                                        Other Expenses
                                      </div>
                                    </div>

                                    {showActionToAssign?.[index] ===
                                      "tasktable" && (
                                        <div
                                          className={`flex  ${operationclicked
                                            ? "justify-center"
                                            : "justify-start"
                                            }`}
                                        >
                                          <div className="w-[50%]">
                                            <div className="head flex text-center bg-[#e8e8e8]  text-xs">
                                              <div className="w-[30%] border-l p-1">
                                                Parts
                                              </div>

                                              <div className="w-[20%]  p-1">
                                                Quantity
                                              </div>
                                              <div className="w-[20%]  p-1">
                                                Unit Cost ({currency})
                                              </div>
                                              <div className="w-[30%] border-r p-1">
                                                Total Cost ({currency})
                                              </div>
                                            </div>
                                            <div className="flex text-center border-b">
                                              <div className="w-[30%] p-1 border-l  text-center">

                                              </div>
                                              <div className="w-[20%] p-1 text-center">

                                              </div>
                                              <div className="w-[20%] p-1 text-center">

                                              </div>
                                              <div className="w-[30%] p-1 border-r text-center text-xs font-semibold">
                                                {USAComma(
                                                  (() => {
                                                    const deduped = Object.values(
                                                      (hardwareEntries || []).reduce((acc, item) => {
                                                        const key = item.assemblepartdescription?.toLowerCase();
                                                        if (!key) return acc;
                                                        if (!acc[key] || Number(item.quantity) > Number(acc[key].quantity)) {
                                                          acc[key] = item;
                                                        }
                                                        return acc;
                                                      }, {})
                                                    );
                                                    return deduped.reduce((sum, item) => sum + (Number(item.totalprice) || 0), 0);
                                                  })()
                                                )}
                                              </div>
                                            </div>
                                            {Object.values(
                                              (hardwareEntries || []).reduce((acc, item) => {
                                                const key = item.assemblepartdescription?.toLowerCase();
                                                if (!key) return acc;
                                                if (!acc[key] || Number(item.quantity) > Number(acc[key].quantity)) {
                                                  acc[key] = item;
                                                }
                                                return acc;
                                              }, {})
                                            ).map(
                                              (entry, index) => (
                                                <div
                                                  key={index}
                                                  className="head flex text-center"
                                                >
                                                  <div className="w-[30%] border-b border-l p-1">
                                                    {entry.assemblepartdescription ||
                                                      ""}
                                                  </div>

                                                  <div className="w-[20%] border-b p-1">
                                                    {entry.quantity || " "}
                                                  </div>
                                                  <div className="w-[20%] border-b p-1">
                                                    {USAComma(
                                                      entry.unitprice || " "
                                                    )}
                                                  </div>
                                                  <div className="w-[30%] border-b border-r p-1">
                                                    {USAComma(
                                                      entry.totalprice || " "
                                                    )}
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      )}

                                    {showActionToAssign?.[index] ===
                                      "otherexpenses" && (
                                        <div
                                          className={`flex ${operationclicked
                                            ? "justify-center"
                                            : "justify-start"
                                            }`}
                                        >
                                          <div className="w-[50%]">
                                            <div className="head flex text-center bg-[#e8e8e8] text-xs">
                                              <div className="w-[10%] border-l p-1">
                                                Sr. No
                                              </div>
                                              <div className="w-[40%]  p-1">
                                                Description
                                              </div>
                                              <div className="w-[20%]  p-1">
                                                Amount ({currency})
                                              </div>
                                              <div className="w-[30%] border-r p-1">
                                                Notes
                                              </div>
                                            </div>
                                            <div className="head flex text-center">
                                              <div className="w-[10%] border-b border-l p-1"></div>
                                              <div className="w-[40%] border-b  p-1">
                                                Total
                                              </div>
                                              <div className="w-[20%] border-b p-1">
                                                {formatAmountComma(
                                                  managerDescriptions?.reduce(
                                                    (sum, item) =>
                                                      sum + parseAmountNumber(item.value),
                                                    0
                                                  ) || 0
                                                )}
                                              </div>
                                              <div className="w-[30%] border-b border-r p-1"></div>
                                            </div>

                                            {managerDescriptions.map(
                                              (entry, index) => (
                                                <div
                                                  key={index}
                                                  className="head flex text-center"
                                                >
                                                  <div className="w-[10%] border-b border-l p-1">
                                                    {index + 1}
                                                  </div>
                                                  <div className="w-[40%] border-b p-1">
                                                    {entry.description}
                                                  </div>
                                                  <div className="w-[20%] border-b p-1">
                                                    {formatAmountComma(entry.value)}
                                                  </div>
                                                  <div className="w-[30%] border-b border-r p-1">
                                                    {entry.notes}
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                )
                                : (activeTaskKey ===
                                  `manager_${index}_${projectIndex}` ||
                                  activeTaskKey?.startsWith(
                                    `operation_${index}_${projectIndex}_`
                                  )) &&
                                (Entries.length > 0 ||
                                  managerDescriptions.length > 0 ? (
                                  <div>
                                    <div
                                      className={`p-1 flex  ${operationclicked
                                        ? "justify-center"
                                        : "justify-start"
                                        } gap-2`}
                                    >
                                      <div
                                        onClick={() =>
                                          setShowActionToAssign((prev) => ({
                                            ...prev,
                                            [index]: "tasktable",
                                          }))
                                        }
                                        className={`cursor-pointer py-2 px-4 inline-block border rounded-md text-start ${showActionToAssign[index] ===
                                          "tasktable"
                                          ? "bg-blue-500 text-white"
                                          : "bg-white"
                                          }`}
                                      >
                                        {/* {project.TypeService === "Hardware"
                                      ? "Part List"
                                      : "Effort Expenses"} */}
                                        {project?.TypeService?.toLowerCase().includes(
                                          "hardware"
                                        )
                                          ? "Part List"
                                          : "Effort Expenses"}
                                      </div>
                                      <div
                                        onClick={() =>
                                          setShowActionToAssign((prev) => ({
                                            ...prev,
                                            [index]: "otherexpenses",
                                          }))
                                        }
                                        className={`cursor-pointer py-2 px-4 inline-block border rounded-md text-start ${showActionToAssign[index] ===
                                          "otherexpenses"
                                          ? "bg-blue-500 text-white"
                                          : "bg-white"
                                          }`}
                                      >
                                        Other Expenses
                                      </div>
                                    </div>

                                    {showActionToAssign?.[index] ===
                                      "tasktable" && (
                                        <div
                                          className={`flex ${operationclicked
                                            ? "justify-center"
                                            : "justify-start"
                                            }  w-full`}
                                        >
                                          <div className="w-[50%] max-h-[14rem] text-end  overflow-scroll ">
                                            <div className="sticky top-0">
                                              <div className="head flex text-center bg-[#e8e8e8]  text-xs">
                                                <div className="w-[10%] border-l p-1">
                                                  Sr.No
                                                </div>
                                                <div className="w-[30%]  p-1">
                                                  Task
                                                </div>
                                                <div className="w-[30%]  p-1">
                                                  Hours
                                                </div>
                                                <div className="w-[30%] border-r p-1">
                                                  Notes
                                                </div>
                                              </div>
                                              <div className="head flex text-center ">
                                                <div className="w-[10%] border-b border-l p-1">
                                                  Sr.No
                                                </div>
                                                <div className="w-[30%]  border-b p-1">
                                                  Total
                                                </div>
                                                <div className="w-[30%] border-b p-1">
                                                  {Entries?.reduce(
                                                    (sum, item) =>
                                                      sum + item.hoursassigned,
                                                    0
                                                  ) || 0}
                                                </div>
                                                <div className="w-[30%] border-r border-b p-1">
                                                  {Entries.length} Tasks
                                                </div>
                                              </div>
                                            </div>

                                            {Entries.map((entry, index) => (
                                              <div
                                                key={index}
                                                className="head flex text-center"
                                              >
                                                <div className="w-[10%] border-b border-l p-1">
                                                  {index + 1}
                                                </div>
                                                <div className="w-[30%] border-b p-1">
                                                  {entry.task}
                                                </div>
                                                <div className="w-[30%] border-b p-1">
                                                  {entry.hoursassigned}
                                                </div>
                                                <div className="w-[30%] border-r border-b p-1">
                                                  {entry.notes}
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        </div>
                                      )}

                                    {showActionToAssign?.[index] ===
                                      "otherexpenses" && (
                                        <div
                                          className={`flex ${operationclicked
                                            ? "justify-center"
                                            : "justify-start"
                                            }   w-full`}
                                        >
                                          <div className="w-[50%] max-h-[14rem]  text-end  overflow-scroll">
                                            <div className="sticky top-0">
                                              <div className="head flex sticky top-0 text-center bg-[#e8e8e8]  text-xs">
                                                <div className="w-[10%] border-l p-1">
                                                  Sr.no
                                                </div>
                                                <div className="w-[30%]  p-1">
                                                  Description
                                                </div>
                                                <div className="w-[30%]  p-1">
                                                  Amount ({currency})
                                                </div>
                                                <div className="w-[30%] border-r p-1">
                                                  Notes
                                                </div>
                                              </div>

                                              <div className="head flex text-center ">
                                                <div className="w-[10%] border-b border-l p-1">
                                                  Sr.no
                                                </div>
                                                <div className="w-[30%]  border-b p-1">
                                                  {"Total"}
                                                </div>
                                                <div className="w-[30%] border-b p-1">
                                                  {formatAmountComma(
                                                    managerDescriptions?.reduce(
                                                      (sum, item) =>
                                                        sum + parseAmountNumber(item.value),
                                                      0
                                                    ) || 0
                                                  )}
                                                </div>
                                                <div className="w-[30%] border-r border-b p-1">
                                                  {managerDescriptions.length}{" "}
                                                  Expenses
                                                </div>
                                              </div>
                                            </div>

                                            {managerDescriptions.map(
                                              (entry, index) => (
                                                <div
                                                  key={index}
                                                  className="head flex text-center"
                                                >
                                                  <div className="w-[10%] border-b border-l p-1">
                                                    {index + 1}
                                                  </div>
                                                  <div className="w-[30%] border-b  p-1">
                                                    {entry.description}
                                                  </div>
                                                  <div className="w-[30%]   border-b p-1">
                                                    {formatAmountComma(entry.value)}
                                                  </div>
                                                  <div className="w-[30%] border-b border-r p-1">
                                                    {entry.notes}
                                                  </div>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                ) : (
                                  <div className="text-center text-red-500 p-1">
                                    No Task Data Available
                                  </div>
                                ))}
                            </div>
                          )
                        })}
                      </div>
                    ) : (
                      <div
                        onClick={() => {
                          setrowid((prev) =>
                            prev === rowKey ? null : rowKey
                          );
                          setSelected(!selected);
                        }}
                        className={` ${rowid ? "" : "w-[20%]"
                          } border-b cursor-pointer border-y flex justify-center align-middle items-center`}
                      >
                        {rowid ? (
                          <div className="flex  group-hover:bg-gray-100">
                            <div
                              onClick={() => setClickedEffort(null)}
                              className="w-28 flex-shrink-0  p-2 py-4 "></div>
                            <div
                              onClick={() => setClickedEffort(null)}
                              className="w-24 flex-shrink-0  p-2 py-4 break-words text-wrap flex justify-center align-middle items-center "></div>
                            <div
                              onClick={() => setClickedEffort(null)}
                              className="w-32 flex-shrink-0  p-2 py-4 "></div>
                            <div
                              onClick={() => setClickedEffort(null)}
                              className="w-28  flex-shrink-0 p-2 py-4 "></div>
                            <div
                              onClick={() => setClickedEffort(null)}
                              className="w-24 flex-shrink-0 flex justify-center align-middle items-center  p-2 py-4 ">
                              View Details
                            </div>
                            <div
                              onClick={() => setClickedEffort(null)}
                              className="w-32 flex-shrink-0  p-2 py-4 "></div>
                            <div
                              onClick={() => setClickedEffort(null)}
                              className="w-48 flex-shrink-0  p-2 py-4 "></div>
                            <div
                              onClick={() => setClickedEffort(null)}
                              className="w-32 flex-shrink-0 p-2 py-4 "></div>
                          </div>
                        ) : (
                          <div className="p-2 flex justify-center align-middle items-center">
                            <button
                              className="flex items-center justify-between
                  text-blue-600
                 p-1 rounded-md
               w-full
                 hover:bg-blue-100 transition"
                            >
                              {/* Left section */}
                              <div className="flex items-center gap-2">
                                <RemoveRedEyeOutlinedIcon fontSize="small" />
                                <span className="text-xs font-medium">
                                  View Details
                                </span>
                                <KeyboardArrowDownOutlinedIcon />
                              </div>
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
              {paginatedProjects.length === 0 && (
                <div className="noDataAvailable p-2">No Result Found</div>
              )}
            </div>
          </div>
        </div>

        <div
          className={`pagination mt-2 flex justify-between  text-xs items-center bg-white pb-2 pl-2 rounded-md ${paginatedProjects.length > 0 ? "p-1" : ""
            } `}
        >
          <div>
            {totalItems > 0 ? (
              <>
                Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                {totalItems} Entries
              </>
            ) : (
              <>
                {paginatedProjects.length > 0 && (
                  <>Showing {paginatedProjects.length} Entries</>
                )}
              </>
            )}
          </div>

          {totalPages > 1 && (
            <div className="flex">
              <button
                onClick={() => setCurrentPage(1)}
                className="px-2 py-2 mx-1 border rounded"
                disabled={currentPage === 1}
                title="First Page"
              >
                <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
              </button>
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                className="px-4 py-2 mx-2 border rounded"
                disabled={currentPage === 1}
              >
                Previous
              </button>

              {Array.from({ length: 3 }, (_, index) => {
                const pageNumber = currentPage - 1 + index;
                if (pageNumber >= 1 && pageNumber <= totalPages) {
                  return (
                    <button
                      key={pageNumber}
                      onClick={() => setCurrentPage(pageNumber)}
                      className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber ? "bg-gray-300" : ""
                        }`}
                    >
                      {pageNumber}
                    </button>
                  );
                }
                return null;
              })}

              <button
                onClick={() =>
                  setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                }
                className="px-4 py-2 mx-2 border rounded"
                disabled={currentPage === totalPages}
              >
                Next
              </button>
              <button
                onClick={() => setCurrentPage(totalPages)}
                className="px-2 py-2 mx-1 border rounded"
                disabled={currentPage === totalPages}
                title="Last Page"
              >
                <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
              </button>
            </div>
          )}
        </div>
      </div>
      {showAttach && (
        <FileUploadSales
          currentProject={currentProject}
          setShowAttach={setShowAttach}
          employees={employees}
          isViewOnly={isViewOnly}
        />
      )}
    </>
  );
};

export default ResponseReceived;
